// Translations for the 23 treatment pages.
// Shape: { "/slug": { title, eyebrow, lead, cta, heroAlt, stats, candidate,
//   techniques, journey, risks, faq, ctaBand, disclaimer, seoTitle, seoDesc } }
// French copy, written to the same clinical rules as the English: no promises,
// no "best clinic", every duration and risk stated as a range.
export default {
  "/abdominoplasty": {
    "title": "Lifting abdominal (abdominoplastie) à Istanbul",
    "eyebrow": "Remodelage corporel",
    "lead": "Le lifting abdominal retire l’excès de peau et de graisse que le régime et l’exercice ne parviennent pas à faire disparaître, et resserre la paroi abdominale sous-jacente. C’est un remodelage de la silhouette, pas une opération de perte de poids.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation d’abdominoplastie à la clinique Platinya",
    "stats": [
      {
        "value": "2–4 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1–2 nuits",
        "label": "Hospitalisation"
      },
      {
        "value": "2–3 semaines",
        "label": "Reprise du travail de bureau"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "L’intervention donne les meilleurs résultats chez une personne dont le poids est stable depuis au moins six mois, dont l’état de santé général est bon et dont la préoccupation porte sur la forme plutôt que sur les kilos.",
      "items": [
        "Peau relâchée ou muscles abdominaux séparés après une grossesse",
        "Peau qui pend après une perte de poids importante, une fois le poids stabilisé",
        "Un bourrelet tenace du bas-ventre qui ne change pas malgré l’entraînement",
        "Des vergetures ou une cicatrice de césarienne situées dans la peau qui sera de toute façon retirée"
      ],
      "note": "Le lifting abdominal n’est pas un traitement de l’obésité et ne remplace pas une perte de poids. Si vous prévoyez une grossesse ou une perte de poids importante, il est généralement préférable d’attendre : le résultat est conçu pour durer."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "La technique est choisie en consultation, à partir de la peau, de la couche musculaire et du tracé de la cicatrice — jamais à partir d’une simple photo.",
      "items": [
        {
          "name": "Abdominoplastie complète",
          "text": "Une incision horizontale basse sur l’abdomen, la peau décollée jusqu’aux côtes, les muscles abdominaux resserrés sur la ligne médiane et l’excès de peau retiré. Le nombril est repositionné. Convient à une peau relâchée au-dessus et au-dessous du nombril."
        },
        {
          "name": "Mini-abdominoplastie",
          "text": "Une incision plus courte et une récupération plus rapide, pour un relâchement cutané limité au bas-ventre. Le nombril reste généralement en place ; le resserrement musculaire est limité."
        },
        {
          "name": "Abdominoplastie étendue",
          "text": "La même intervention que l’abdominoplastie complète, prolongée autour des flancs, pour une peau qui pend aussi sur les côtés. Souvent associée à une liposuccion de la taille."
        },
        {
          "name": "Réparation musculaire (plicature)",
          "text": "Lorsque les muscles droits de l’abdomen se sont écartés — fréquent après une grossesse — ils sont suturés pour être rapprochés de la ligne médiane. C’est ce geste qui modifie le profil de l’abdomen, et pas seulement la peau."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Des photographies, un historique médical et une conversation franche sur les cicatrices, l’arrêt d’activité et ce que l’intervention peut ou ne peut pas faire. Des analyses de sang et, si nécessaire, une échographie ou un avis cardiologique sont organisés avant de fixer une date."
        },
        {
          "name": "Préparation",
          "text": "Le tabac est arrêté au moins trois à quatre semaines avant l’intervention, les anticoagulants et certains compléments sont suspendus environ dix jours avant, et vous restez à jeun pendant six à huit heures. Organisez-vous pour que quelqu’un vienne vous chercher et vous aide à la maison la première semaine."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale, elle dure généralement deux à quatre heures. Un drain est souvent laissé en place quelques jours. La plupart des patients restent une ou deux nuits à l’hôpital, avec des vêtements de compression ajustés avant la sortie."
        },
        {
          "name": "Les deux premières semaines",
          "text": "La marche commence dès le premier jour, sur de courtes distances, le dos droit. Le vêtement de compression se porte jour et nuit. L’œdème atteint son maximum vers le troisième au cinquième jour puis diminue ; la première douche et le retrait du drain sont programmés à la clinique."
        },
        {
          "name": "Semaines trois à six",
          "text": "Le travail de bureau est généralement possible après deux à trois semaines. La salle de sport, la natation et le port de charges attendent environ la sixième semaine, lorsque le chirurgien confirme que les tissus sont cicatrisés."
        },
        {
          "name": "La cicatrice, sur un an",
          "text": "La cicatrice est rouge et ferme les premiers mois, puis s’éclaircit et s’aplatit — un processus qui se poursuit pendant douze à dix-huit mois. Elle est située bas, dans la ligne du sous-vêtement."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Toute intervention comporte des risques, et il vaut mieux les entendre avant de décider que après.",
      "items": [
        "Sérome — une collection de liquide sous la peau ; c’est le problème le plus fréquent, généralement drainé à la clinique",
        "Infection ou retard de cicatrisation, plus probable chez les fumeurs",
        "Cicatrice large ou surélevée, qui pourra être reprise plus tard mais pas effacée",
        "Insensibilité autour de la cicatrice et du nombril, qui s’améliore habituellement en quelques mois",
        "Asymétrie ou un contour nécessitant une petite reprise (environ un patient sur dix)",
        "Saignement, hématomes et, rarement, thrombose — prévenus par la marche précoce et la compression"
      ],
      "note": "Parlez-nous du tabac, du diabète, des anticoagulants et de toute chirurgie abdominale antérieure lors de la consultation. Chacun de ces éléments modifie le plan, et le cacher est le chemin le plus rapide vers une récupération compliquée."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Est-ce que cela fait mal ?",
          "a": "Les deux ou trois premiers jours sont inconfortables plutôt que douloureux — une sensation de tension et d’hématome dans l’abdomen. Cela se gère avec des antalgiques ordinaires, et la plupart des patients marchent et mangent normalement avant la sortie."
        },
        {
          "q": "La cicatrice sera-t-elle visible ?",
          "a": "Il y a une cicatrice, et elle est définitive. Elle est placée bas, le long de la ligne du sous-vêtement, et s’éclaircit en douze à dix-huit mois. La façon dont elle cicatrise dépend de votre peau, du fait de ne pas fumer et du respect des consignes de soins de la plaie."
        },
        {
          "q": "Puis-je avoir des enfants ensuite ?",
          "a": "En général oui, mais l’abdomen se distendra à nouveau pendant la grossesse et une partie du résultat peut être perdue. C’est pourquoi de nombreux chirurgiens conseillent de terminer sa famille d’abord."
        },
        {
          "q": "Peut-on l’associer à une liposuccion ?",
          "a": "Souvent oui — une liposuccion des flancs ou de la taille est fréquemment ajoutée pour harmoniser la transition. Sa sécurité dans votre cas dépend de la zone concernée et de la durée de l’intervention, et c’est une décision chirurgicale."
        },
        {
          "q": "Combien de poids vais-je perdre ?",
          "a": "Un peu, mais là n’est pas la question. L’intervention modifie la forme de l’abdomen. Si votre objectif est une perte de poids, une évaluation de chirurgie bariatrique est le bon point de départ, pas un lifting abdominal."
        },
        {
          "q": "Combien cela coûte-t-il ?",
          "a": "Le prix dépend de la technique, de l’hôpital, de la durée du séjour et de la nécessité d’une réparation musculaire ; il est donc établi après l’évaluation et non avant. Le devis comprend l’intervention, l’anesthésie, l’hospitalisation, les vêtements de compression et les visites de suivi."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Un chirurgien les examine et un coordinateur revient vers vous avec un plan, une date et un devis écrit — sans engagement et sans pression pour réserver.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Lifting abdominal (abdominoplastie) à Istanbul | Platinya",
    "seoDesc": "Lifting abdominal à Istanbul : excès de peau retiré, muscles resserrés. Une à deux nuits sur place, reprise du travail en deux à trois semaines."
  },
  "/hair-transplant": {
    "title": "Greffe de cheveux à Istanbul (FUE)",
    "eyebrow": "Restauration capillaire",
    "lead": "Des follicules pileux sont prélevés à l’arrière du cuir chevelu — où ils résistent à la chute — et implantés dans les zones qui se sont éclaircies. Le résultat est votre propre cheveu, poussant là où il ne poussait plus.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Évaluation de greffe de cheveux à la clinique Platinya",
    "stats": [
      {
        "value": "6–9 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1 jour",
        "label": "À la clinique"
      },
      {
        "value": "12–18 mois",
        "label": "Résultat final"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Le facteur limitant n’est pas la quantité de cheveux manquants, mais la quantité de cheveux donneurs disponibles à l’arrière et sur les côtés, et la stabilité de la perte.",
      "items": [
        "Une perte stabilisée depuis environ un an, et non une chute semaine après semaine",
        "Une densité suffisante dans la zone donneuse pour le nombre de greffons dont la zone dégarnie a besoin",
        "Une ligne frontale qui recule, une perte aux tempes ou un éclaircissement du vertex",
        "Des attentes réalistes : la densité s’améliore, mais une zone dégarnie n’est jamais restaurée à la densité de l’adolescence"
      ],
      "note": "Si la perte est encore active, la traiter d’abord — médicalement — protège le résultat. Une greffe déplace des cheveux ; elle n’empêche pas ceux que vous avez encore de s’éclaircir plus tard."
    },
    "techniques": {
      "heading": "Comment les cheveux sont prélevés et implantés",
      "intro": "La méthode est choisie selon la densité donneuse, la taille de la zone et la coiffure que vous souhaitez conserver.",
      "items": [
        {
          "name": "FUE — extraction d’unités folliculaires",
          "text": "Des follicules individuels sont prélevés par micro-poinçon puis réimplantés. Aucune bande de peau n’est retirée, donc pas de cicatrice linéaire ; en contrepartie, la zone donneuse est rasée et la cicatrisation prend quelques jours."
        },
        {
          "name": "DHI — implantation directe",
          "text": "Les follicules sont placés avec un stylo implanteur à usage unique, ce qui permet un contrôle serré de l’angle et de la profondeur sur la ligne frontale. Plus lent, donc moins de greffons par séance."
        },
        {
          "name": "Dessin de la ligne frontale",
          "text": "La ligne est tracée avec vous, assis puis debout, avant toute coupe : elle doit résister au vieillissement et à une perte ultérieure, c’est pourquoi elle est placée de façon prudente plutôt que basse."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation au résultat final",
      "steps": [
        {
          "name": "Évaluation",
          "text": "La densité donneuse est mesurée, la ligne frontale est dessinée et des analyses de sang sont organisées. Des photographies sont prises sous cinq angles pour comparaison ultérieure."
        },
        {
          "name": "Le jour même",
          "text": "Anesthésie locale avec sédation légère ; vous êtes éveillé et pouvez manger. La séance est longue — six à neuf heures — et entrecoupée de courtes pauses."
        },
        {
          "name": "Les dix premiers jours",
          "text": "De petites croûtes se forment et sont lavées délicatement à partir du deuxième jour. Un œdème sur le front est fréquent et se résorbe en une semaine."
        },
        {
          "name": "Semaines 3 à 12",
          "text": "La majeure partie des cheveux greffés tombe — c’est attendu et ne signifie pas un échec. La repousse commence vers le troisième mois."
        },
        {
          "name": "À partir du douzième mois",
          "text": "La densité et l’épaisseur continuent de s’améliorer jusqu’à 12–18 mois. Une seconde séance pour ajouter de la densité, si souhaitée, est planifiée au plus tôt douze mois après."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Une greffe est une vraie opération avec de vraies limites. Voici celles qu’il faut connaître avant de réserver.",
      "items": [
        "Œdème, rougeurs et croûtes la première semaine, et insensibilité temporaire du cuir chevelu",
        "La survie des follicules n’est jamais de 100 % ; une proportion de greffons ne pousse pas",
        "Une couverture irrégulière ou clairsemée si le nombre de greffons prévu n’est pas couvert par la réserve donneuse",
        "Folliculite — petits points infectés dans la zone receveuse, généralement traitables",
        "Une ligne frontale artificielle si le dessin est trop bas ou trop dense pour la zone donneuse"
      ],
      "note": "Choisissez le plan sur le nombre de greffons et la qualité de la zone donneuse, pas sur le prix le plus bas : une séance bon marché qui sur-prélève la zone donneuse ne peut pas être annulée."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Est-ce douloureux ?",
          "a": "Les injections piquent quelques secondes ; ensuite le cuir chevelu est insensible et l’intervention est surtout ennuyeuse plutôt que douloureuse. La première nuit est sensible et se calme avec des antalgiques ordinaires."
        },
        {
          "q": "Y aura-t-il une cicatrice ?",
          "a": "La FUE laisse de minuscules marques circulaires dans la zone donneuse, qui s’effacent jusqu’à devenir presque invisibles à longueur normale. La technique par bandelette laisse une fine ligne en travers de l’arrière du cuir chevelu."
        },
        {
          "q": "Quand puis-je reprendre le travail ?",
          "a": "Le travail de bureau après deux à trois jours, une fois l’œdème résorbé. Le sport intense, le sauna et la natation attendent environ deux semaines."
        },
        {
          "q": "Les nouveaux cheveux durent-ils ?",
          "a": "Les follicules greffés conservent le comportement de la zone donneuse et sont généralement définitifs. Les cheveux qui les entourent peuvent encore s’éclaircir, c’est pourquoi un traitement médical est souvent poursuivi."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Des photos de la ligne frontale, du vertex et de la zone donneuse suffisent pour dire si une greffe est pertinente, environ combien de greffons, et ce que cela coûterait.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen du cuir chevelu et de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Greffe de cheveux à Istanbul (FUE) | Clinique Platinya",
    "seoDesc": "Greffe de cheveux FUE à Istanbul : vos propres follicules déplacés vers les zones clairsemées. Une journée à la clinique, résultat final à 12 ou 18 mois."
  },
  "/sapphire-hair-transplant": {
    "title": "Greffe de cheveux FUE au saphir à Istanbul",
    "eyebrow": "Restauration capillaire",
    "lead": "La FUE au saphir est la même extraction d’unités folliculaires que la FUE standard, mais les canaux recevant les greffons sont ouverts avec des lames en saphir plutôt qu’en acier. La différence tient aux incisions, pas aux follicules.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Planification d’une greffe FUE au saphir à la clinique Platinya",
    "stats": [
      {
        "value": "6–8 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1 jour",
        "label": "À la clinique"
      },
      {
        "value": "10–14 jours",
        "label": "Croûtes disparues"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Le saphir est une technique, pas un critère d’éligibilité : les mêmes règles s’appliquent qu’à toute greffe — une perte stabilisée et assez de cheveux donneurs.",
      "items": [
        "Une perte stabilisée, avec une zone donneuse saine à l’arrière et sur les côtés",
        "Un éclaircissement de la ligne frontale, des tempes ou du vertex que le traitement médical seul n’a pas corrigé",
        "Une peau sans infection active, eczéma ni psoriasis dans la zone receveuse",
        "La compréhension que la lame modifie la cicatrisation, pas le nombre de greffons que vous pouvez vous permettre"
      ],
      "note": "Les cliniques qui présentent le saphir comme une garantie de cheveux plus denses survendent l’instrument. La survie des greffons dépend de la façon dont les follicules sont manipulés, pas de la lame seule."
    },
    "techniques": {
      "heading": "Ce que change la lame en saphir",
      "intro": "La même opération, avec un tranchant différent et un autre ensemble de compromis.",
      "items": [
        {
          "name": "Des canaux plus étroits",
          "text": "Les lames en saphir créent une fente plus fine que l’acier : le tissu est séparé plutôt que déchiré. Des ouvertures plus petites signifient moins de croûtes et, chez la plupart des patients, une cicatrisation plus rapide."
        },
        {
          "name": "Un ajustement plus serré du greffon",
          "text": "Un greffon bien ajusté dans son canal bouge moins les premiers jours. Cela compte surtout sur la ligne frontale, où la direction et l’angle sont visibles."
        },
        {
          "name": "Ce que cela ne change pas",
          "text": "Cela n’augmente pas le nombre de greffons que votre zone donneuse peut fournir et ne remplace pas le plan : la densité, le dessin de la ligne frontale et la manipulation des follicules par l’équipe décident du résultat."
        }
      ]
    },
    "journey": {
      "heading": "La journée, heure par heure",
      "steps": [
        {
          "name": "Dessin et rasage",
          "text": "La ligne frontale est tracée et validée avant toute coupe. La zone donneuse est coupée court ; la zone receveuse est rasée dans la plupart des cas."
        },
        {
          "name": "Anesthésie",
          "text": "Injections d’anesthésique local avec sédation légère. L’inconfort se limite aux premières minutes."
        },
        {
          "name": "Prélèvement et canaux",
          "text": "Les follicules sont prélevés, conservés au frais en solution, et les canaux au saphir sont ouverts selon l’angle exigé par la ligne frontale."
        },
        {
          "name": "Implantation",
          "text": "Les greffons sont placés un par un. L’équipe travaille par relais sur les longues séances pour garder une manipulation régulière."
        },
        {
          "name": "Cicatrisation",
          "text": "De minuscules croûtes tombent en 10 à 14 jours. Les cheveux greffés tombent à partir de la troisième semaine, puis repoussent à partir du troisième mois."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Toute greffe comporte les mêmes risques essentiels, quelle que soit la lame.",
      "items": [
        "Œdème, sensibilité et insensibilité temporaire dans les zones donneuse et receveuse",
        "Croûtes et rougeurs qui durent plus longtemps que prévu sur une peau sensible",
        "Certains greffons ne survivent pas, ce qui explique qu’une seconde séance soit parfois nécessaire",
        "Folliculite ou petits kystes autour des nouveaux greffons les premières semaines",
        "Une ligne frontale qui paraît trop droite ou trop dense si le dessin n’était pas prudent"
      ],
      "note": "Demandez combien de greffons sont prévus, qui ouvre les canaux et qui implante — les réponses en disent plus sur le résultat que le mot « saphir »."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Le saphir est-il meilleur que la FUE en acier ?",
          "a": "La cicatrisation est un peu plus rapide et les croûtes moins nombreuses. Les preuves indépendantes d’une repousse supérieure sont faibles ; la manipulation des greffons par le chirurgien compte davantage."
        },
        {
          "q": "Est-ce plus douloureux ?",
          "a": "Non. L’anesthésie est la même ; la lame est utilisée sur une peau insensibilisée."
        },
        {
          "q": "Quand les croûtes disparaissent-elles ?",
          "a": "Généralement en 10 à 14 jours, avec un lavage délicat à partir du deuxième jour."
        },
        {
          "q": "Une séance suffit-elle ?",
          "a": "Pour beaucoup de patients, oui. Les grandes zones dégarnies ou une faible densité donneuse peuvent nécessiter une seconde séance après 12 mois pour atteindre la densité prévue."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Nous vous dirons honnêtement si la FUE au saphir apporte quelque chose dans votre cas, et quel serait le nombre de greffons.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité est décidée après examen ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Greffe de cheveux FUE au saphir à Istanbul | Platinya",
    "seoDesc": "FUE au saphir à Istanbul : canaux plus fins, moins de croûtes, cicatrisation plus rapide. Limites de la technique et nombre de greffons expliqués."
  },
  "/hair-implant-hybrid": {
    "title": "Greffe de cheveux hybride (FUE + FUT) à Istanbul",
    "eyebrow": "Restauration capillaire",
    "lead": "Une séance hybride utilise les deux façons de prélever les cheveux — une fine bandelette à l’arrière du cuir chevelu et des unités folliculaires individuelles — en une seule opération, lorsque une méthode seule ne peut pas fournir le nombre de greffons dont la zone dégarnie a besoin.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Comparaison des techniques de greffe hybride à la clinique Platinya",
    "stats": [
      {
        "value": "1 séance",
        "label": "Deux techniques"
      },
      {
        "value": "+30 à 50 %",
        "label": "Greffons par rapport à la FUE seule"
      },
      {
        "value": "12 mois",
        "label": "Pour juger le résultat"
      }
    ],
    "candidate": {
      "heading": "À qui cela s’adresse",
      "intro": "L’hybride est un problème de réserve résolu avec deux outils : il existe pour les grandes zones dégarnies et une zone donneuse qui n’est pas assez dense pour tout fournir par extraction seule.",
      "items": [
        "Une perte avancée — Norwood 5 à 6 — où une seule séance de FUE laisserait le vertex clairsemé",
        "Une bonne densité dans la zone de la bandelette mais un nombre limité d’unités folliculaires extractibles",
        "Une séance de FUE antérieure qui a épuisé les sites donneurs accessibles",
        "L’acceptation d’une fine cicatrice linéaire en échange de nettement plus de greffons"
      ],
      "note": "Plus de greffons n’est pas automatiquement mieux. L’hybride a du sens lorsque le plan a réellement besoin de ces chiffres supplémentaires ; pour des zones plus petites, une seule technique est plus simple et cicatrise plus vite."
    },
    "techniques": {
      "heading": "Comment les deux volets s’articulent",
      "intro": "La bandelette est prélevée d’abord, puis l’extraction complète le reste du plan — une anesthésie, une journée.",
      "items": [
        {
          "name": "La bandelette (FUT)",
          "text": "Une fine ellipse de cuir chevelu est retirée à l’arrière, fermée en plusieurs plans et disséquée en greffons individuels sous microscope. C’est la source la plus dense de greffons par centimètre carré."
        },
        {
          "name": "L’extraction (FUE)",
          "text": "Les follicules sont ensuite prélevés un à un sur les côtés, ce qui ajoute des greffons sans nouvelle ligne cicatricielle — et, surtout, sans fragiliser la fermeture de la bandelette."
        },
        {
          "name": "Pourquoi ne pas simplement faire plus de FUE",
          "text": "Parce que sur-prélever une zone donneuse la laisse irrégulière et ferme la porte à toute séance future. L’hybride répartit la charge sur deux zones donneuses."
        }
      ]
    },
    "journey": {
      "heading": "De la planification au résultat final",
      "steps": [
        {
          "name": "Budget de greffons",
          "text": "La densité donneuse de la zone de bandelette et celle de la zone d’extraction sont mesurées séparément, et le nombre de greffons que chacune peut fournir est additionné. Ce total fixe le plan."
        },
        {
          "name": "Le jour de l’intervention",
          "text": "Le prélèvement de la bandelette prend environ une heure ; l’équipe dissèque pendant que l’extraction se poursuit. Comptez huit à dix heures au total pour une grande séance."
        },
        {
          "name": "Les deux premières semaines",
          "text": "La ligne de la bandelette est fermée par des fils ou des agrafes, retirés vers le dixième au quatorzième jour. Les croûtes de la zone receveuse disparaissent dans la même période."
        },
        {
          "name": "Mois 1 à 3",
          "text": "Les cheveux greffés tombent, puis la repousse commence. La cicatrice linéaire passe du rouge au pâle."
        },
        {
          "name": "Mois 12 à 18",
          "text": "Densité définitive. À longueur normale, la cicatrice de la bandelette est généralement couverte par les cheveux alentour ; les coupes très courtes la laisseront voir."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "L’hybride cumule les risques des deux techniques à la fois.",
      "items": [
        "Une cicatrice linéaire définitive en travers de l’arrière du cuir chevelu, cachée par les cheveux à longueur normale",
        "Une tension ou un étirement de la cicatrice si la fermeture est sous tension ou si la cicatrisation est mauvaise",
        "Une insensibilité temporaire au-dessus de la cicatrice, pouvant mettre des mois à se résorber",
        "Les risques habituels de toute greffe : œdème, folliculite, perte partielle de greffons",
        "Une séance longue — la fatigue affecte le patient comme l’équipe, c’est pourquoi la journée est planifiée par étapes"
      ],
      "note": "Demandez qui réalise la fermeture de la bandelette et combien de séances hybrides la clinique pratique par mois. La fermeture est la partie que les patients jugent des années plus tard."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de greffons un hybride peut-il fournir ?",
          "a": "Couramment 4 000 à 6 000 en une séance pour une zone donneuse adaptée, contre environ 2 500 à 3 500 avec la FUE seule. Le chiffre exact se mesure, il ne se promet pas."
        },
        {
          "q": "La cicatrice se verra-t-elle ?",
          "a": "À longueur normale de cheveux, généralement non. Avec un crâne rasé ou une coupe très dégradée, elle est visible comme une ligne pâle, et cela doit être accepté avant de réserver."
        },
        {
          "q": "Est-ce plus douloureux que la FUE ?",
          "a": "Les deux premières nuits sont plus tendues à cause de la fermeture. Ensuite, les deux zones se ressemblent ; la zone de la bandelette est souvent décrite comme une douleur contusive."
        },
        {
          "q": "Puis-je faire une FUE plus tard ?",
          "a": "Oui, si les zones d’extraction n’ont pas été épuisées. C’est précisément pourquoi le plan répartit la zone donneuse sur les séances futures plutôt que de tout consommer d’un coup."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Nous mesurerons les deux zones donneuses et vous dirons si un hybride apporte quelque chose de plus qu’une technique unique.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité et le nombre de greffons sont décidés après examen ; les résultats varient.",
    "seoTitle": "Greffe de cheveux hybride (FUE + FUT) à Istanbul | Platinya",
    "seoDesc": "Greffe hybride à Istanbul : bandelette et extraction en une séance pour les zones étendues. Greffons, cicatrice linéaire et suites expliqués."
  },
  "/hair-transplant-for-women": {
    "title": "Greffe de cheveux pour les femmes à Istanbul",
    "eyebrow": "Restauration capillaire",
    "lead": "La perte de cheveux féminine se présente généralement comme un éclaircissement diffus plutôt que comme une plaque dégarnie, et elle a souvent une cause qui peut être traitée. La greffe s’envisage après avoir écarté ces causes — et elle fonctionne différemment de l’opération masculine.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation pour la perte de cheveux chez la femme à la clinique Platinya",
    "stats": [
      {
        "value": "1 jour",
        "label": "À la clinique"
      },
      {
        "value": "Sans rasage",
        "label": "Dans la plupart des cas"
      },
      {
        "value": "12 mois",
        "label": "Pour juger la densité"
      }
    ],
    "candidate": {
      "heading": "À qui cela aide — et à qui non",
      "intro": "Chez la femme, la première question n’est pas « combien de greffons » mais « pourquoi les cheveux s’éclaircissent ». Le bilan sanguin précède tout plan chirurgical.",
      "items": [
        "Un éclaircissement qui persiste malgré des résultats normaux en fer, thyroïde, vitamine D et hormones",
        "Un éclaircissement localisé à la raie, aux tempes ou le long de la ligne frontale",
        "Des cicatrices de traction, de brûlure, de chirurgie ou d’alopécie stable depuis un an",
        "Une perte de sourcils ou de ligne frontale après une épilation excessive ou un traumatisme de maquillage permanent"
      ],
      "note": "Une chute diffuse sur tout le cuir chevelu — effluvium télogène — est généralement réversible et ne se traite pas par la chirurgie. Une carence en fer, une maladie thyroïdienne, un syndrome des ovaires polykystiques et une chute du post-partum sont recherchés d’abord, car greffer pendant une chute active gaspille des greffons."
    },
    "techniques": {
      "heading": "En quoi l’opération féminine diffère",
      "intro": "Le principe est le même, les modalités pratiques non : moins de rasage, moins de greffons, plus d’attention à la façon dont les cheveux tombent.",
      "items": [
        {
          "name": "Rasage partiel ou absent",
          "text": "Les follicules peuvent être prélevés dans une bande étroite que les cheveux alentour recouvrent, ce qui évite de raser la zone donneuse. L’extraction est plus lente, les séances sont donc plus petites."
        },
        {
          "name": "Densité, pas couverture",
          "text": "La perte féminine consiste à ajouter de la densité entre les cheveux existants plutôt qu’à reconstruire une ligne frontale. Les greffons sont placés entre les follicules natifs, selon un angle qui suit la chute naturelle."
        },
        {
          "name": "Associée à un traitement médical",
          "text": "Le minoxidil, et dans certains cas un médicament prescrit, est généralement poursuivi avant et après l’intervention — la greffe ajoute de la densité, elle n’arrête pas le processus sous-jacent."
        }
      ]
    },
    "journey": {
      "heading": "Dès la première consultation",
      "steps": [
        {
          "name": "Les causes d’abord",
          "text": "Des analyses de sang, l’historique des schémas de chute et un examen trichoscopique. Si une cause réversible est trouvée, elle est traitée avant de reparler de chirurgie."
        },
        {
          "name": "Planifier la densité",
          "text": "La zone est cartographiée et le nombre de greffons reste délibérément modeste — une implantation trop dense sur un cuir chevelu féminin clairsemé peut abîmer les cheveux encore présents."
        },
        {
          "name": "Le jour de l’intervention",
          "text": "Anesthésie locale ; la séance dure généralement quatre à six heures. La plupart des patientes rentrent le jour même."
        },
        {
          "name": "Le premier mois",
          "text": "L’œdème et la sensibilité disparaissent en quelques jours. Les cheveux greffés tombent à partir de la troisième semaine — c’est attendu."
        },
        {
          "name": "Mois 6 à 12",
          "text": "La densité se construit progressivement. La couleur et la texture s’accordent aux cheveux environnants à mesure qu’ils mûrissent."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Les risques sont les risques habituels, avec deux qui comptent davantage chez la femme.",
      "items": [
        "Une chute de choc des cheveux autour des greffons dans les premières semaines — généralement temporaire mais impressionnante",
        "Un placement trop dense abîmant les follicules natifs d’un cuir chevelu clairsemé",
        "Un résultat irrégulier si la cause sous-jacente était encore active pendant l’intervention",
        "Folliculite, croûtes et insensibilité temporaire",
        "Un changement visible de texture des cheveux dans la zone greffée chez une minorité de patientes"
      ],
      "note": "Toute clinique qui propose une intervention sans poser de questions sur le fer, la thyroïde et les hormones saute précisément l’étape qui détermine si l’opération valait la peine."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Devrai-je me raser la tête ?",
          "a": "En général non. La plupart des séances féminines utilisent une bande donneuse partiellement rasée que les cheveux alentour recouvrent, ou aucun rasage avec une extraction plus lente."
        },
        {
          "q": "Puis-je me coiffer normalement ensuite ?",
          "a": "Après une dizaine de jours, oui — en douceur. La coloration et la permanente attendent six à huit semaines, et les queues-de-cheval serrées ou les tresses sont évitées le premier mois."
        },
        {
          "q": "Une séance suffit-elle ?",
          "a": "Souvent deux séances sont prévues pour un éclaircissement diffus, espacées de douze mois, car ajouter de la densité progressivement protège les cheveux existants."
        },
        {
          "q": "Et si la cause est hormonale ?",
          "a": "Alors le traitement hormonal est la base et la chirurgie n’est qu’un complément. Opérer pendant que la perte est active donne un résultat qui s’éclaircit autour des greffons."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Des photos de la raie, de la ligne frontale et de la zone donneuse, ainsi que vos derniers résultats sanguins, suffisent pour un premier avis — y compris pour dire si la chirurgie est réellement la bonne réponse.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La perte de cheveux féminine nécessite un diagnostic avant tout plan chirurgical ; les résultats varient.",
    "seoTitle": "Greffe de cheveux pour femmes à Istanbul | Platinya",
    "seoDesc": "Perte de cheveux féminine à Istanbul : causes vérifiées d’abord, puis greffe sans rasage si possible. Densité et limites expliquées."
  },
  "/eyebrow-transplant": {
    "title": "Greffe de sourcils à Istanbul",
    "eyebrow": "Restauration capillaire",
    "lead": "Des cheveux isolés sont prélevés sur le cuir chevelu et implantés dans le sourcil selon l’angle de pousse de chaque poil, pour reconstruire un sourcil que l’épilation excessive, une cicatrice ou la génétique a rendu clairsemé.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de greffe de sourcils à la clinique Platinya",
    "stats": [
      {
        "value": "3–4 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "200–400",
        "label": "Greffons par sourcil"
      },
      {
        "value": "6–9 mois",
        "label": "Forme définitive"
      }
    ],
    "candidate": {
      "heading": "À qui cela s’adresse",
      "intro": "Les sourcils sont la greffe la plus visible du visage : la première question est donc de savoir si la forme existe encore et peut être reconstruite.",
      "items": [
        "Un éclaircissement dû à des années d’épilation excessive, lorsque les follicules ne récupèrent plus",
        "Des cicatrices de brûlure, de coupure ou de détatouage de maquillage permanent",
        "Des sourcils naturellement clairsemés ou asymétriques, ou une perte après chimiothérapie qui ne s’est pas rétablie",
        "Une peau saine, sans eczéma, psoriasis ni infection active dans la zone du sourcil"
      ],
      "note": "Si le sourcil est clairsemé à cause d’une maladie thyroïdienne ou d’une carence nutritionnelle, cela se traite d’abord. Les cheveux prélevés sur le cuir chevelu continuent de pousser comme des cheveux : ils devront donc être taillés — c’est un entretien définitif, à bien comprendre avant de réserver."
    },
    "techniques": {
      "heading": "Comment cela se fait",
      "intro": "La précision plutôt que le volume : quelques centaines de cheveux isolés, chacun placé à son propre angle.",
      "items": [
        {
          "name": "Greffons à un seul cheveu",
          "text": "Seules des unités folliculaires à un ou deux cheveux sont utilisées. Les greffons plurifolliculaires donnent un aspect en touffe dans un sourcil ; la zone donneuse est donc choisie pour ses cheveux fins et isolés, souvent derrière l’oreille."
        },
        {
          "name": "Angle et direction",
          "text": "Les poils du sourcil poussent vers le haut et vers l’extérieur à la tête du sourcil, puis s’aplatissent vers la queue. Chaque greffon est placé individuellement pour suivre ce schéma, faute de quoi le résultat paraît artificiel."
        },
        {
          "name": "Densité en deux temps",
          "text": "Une première passe prudente protège la vascularisation de la peau fine du sourcil ; une seconde séance après 9 à 12 mois ajoute de la densité là où elle est nécessaire, plutôt que de surcharger d’emblée."
        }
      ]
    },
    "journey": {
      "heading": "Du dessin à la forme définitive",
      "steps": [
        {
          "name": "Dessin sur le visage",
          "text": "Le sourcil est dessiné avec vous en position assise, mesuré par rapport à l’autre côté et aux proportions du visage, et validé avant tout prélèvement."
        },
        {
          "name": "L’intervention",
          "text": "Anesthésie locale. Prélèvement dans la zone donneuse, puis implantation à l’aiguille fine. Trois à quatre heures pour les deux sourcils."
        },
        {
          "name": "Les dix premiers jours",
          "text": "Petites croûtes ; pas de maquillage sur la zone, pas de frottement, pas de sommeil sur le ventre. L’œdème se résorbe en une semaine."
        },
        {
          "name": "Semaines 3 à 8",
          "text": "La plupart des greffons tombent, ce qui est normal. Le sourcil paraît plus clairsemé que le jour de l’intervention pendant un certain temps."
        },
        {
          "name": "Mois 6 à 9",
          "text": "Les nouveaux poils sont établis. À partir de là, ils poussent longs et sont taillés aux petits ciseaux toutes les quelques semaines."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Sur le visage, les petites erreurs techniques se voient. Voici celles à discuter.",
      "items": [
        "Une direction artificielle ou une zone trop dense qui ressemble à une touffe",
        "Une asymétrie entre les deux sourcils — la symétrie parfaite n’est pas atteignable",
        "Une perte de greffons sur une peau cicatricielle, où la vascularisation est plus faible",
        "Une folliculite ou de petits kystes dans les premières semaines",
        "Des cheveux qui poussent plus vite et plus longs que ceux du sourcil d’origine, nécessitant une taille régulière"
      ],
      "note": "Demandez à voir des résultats cicatrisés à six mois ou plus, pas le lendemain de l’intervention. La direction et la densité ne deviennent visibles qu’une fois les cheveux stabilisés."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Le résultat sera-t-il naturel ?",
          "a": "Lorsque des cheveux isolés sont utilisés et placés au bon angle, oui — à distance de conversation, cela se lit comme un sourcil normal. Le risque est la surdensité, c’est pourquoi la première passe est prudente."
        },
        {
          "q": "Puis-je encore les épiler ?",
          "a": "Oui, mais avec précaution. L’épilation à la pince et à la cire est évitée ; la taille aux ciseaux est la façon d’entretenir des sourcils greffés."
        },
        {
          "q": "Quand puis-je remettre du maquillage ?",
          "a": "Après environ 7 à 10 jours, une fois les croûtes parties et la peau fermée."
        },
        {
          "q": "Ai-je besoin d’une seconde séance ?",
          "a": "Souvent oui, pour la densité, planifiée après 9 à 12 mois. La première séance vise à établir la forme, la seconde à la remplir."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Une photo rapprochée de chaque sourcil, de face et de trois quarts, suffit pour juger ce qui peut être reconstruit.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité pour les sourcils se juge en présentiel ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Greffe de sourcils à Istanbul | Clinique Platinya",
    "seoDesc": "Greffe de sourcils à Istanbul avec des greffons à cheveu unique placés à l’angle naturel. Trois à quatre heures, forme définitive à six à neuf mois."
  },
  "/hollywood-smile": {
    "title": "Hollywood Smile à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "Un Hollywood Smile est un plan plutôt qu’un acte isolé : la forme, la couleur et les proportions des dents antérieures sont conçues ensemble, puis réalisées avec des facettes, des couronnes et — lorsque la ligne gingivale est irrégulière — un remodelage gingival. La plupart des plans se terminent en cinq à sept jours.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation Hollywood Smile à la clinique Platinya",
    "stats": [
      {
        "value": "5–7 jours",
        "label": "Plan habituel"
      },
      {
        "value": "8–20",
        "label": "Dents généralement concernées"
      },
      {
        "value": "10–15 ans",
        "label": "Durée de vie avec entretien"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "La conception doit s’adapter au visage et à l’occlusion. Un sourire juste en photographie peut être inadapté à une bouche qui serre les dents, ou à des lèvres qui découvrent beaucoup de gencive.",
      "items": [
        "Dents antérieures ébréchées, usées sur les bords ou colorées d’une façon que l’éclaircissement ne corrigera pas",
        "De petits espaces, ou des dents pivotées ou légèrement mal alignées, mais pas assez pour nécessiter de l’orthodontie",
        "D’anciennes couronnes ou de grandes obturations antérieures qui ne s’accordent plus aux dents voisines",
        "Une ligne gingivale irrégulière, où certaines dents paraissent plus longues que d’autres"
      ],
      "note": "Les dents et les gencives doivent d’abord être saines. Une carie active, une maladie parodontale ou une occlusion instable se traite avant toute facette ; sinon, le nouvel ouvrage est construit sur quelque chose qui bouge encore."
    },
    "techniques": {
      "heading": "Comment le sourire est construit",
      "intro": "Le dosage se décide selon la quantité de dent restante, la quantité d’émail disponible et l’ampleur réelle du changement souhaité.",
      "items": [
        {
          "name": "Conception numérique et sourire d’essai",
          "text": "Des photographies et une empreinte optique intra-buccale servent à concevoir le sourire à l’écran, avec des proportions tirées de votre visage plutôt que d’un modèle standard. La conception est imprimée en maquette et collée temporairement sur vos dents : vous pouvez la voir, parler avec elle et la modifier avant tout geste définitif."
        },
        {
          "name": "Facettes et couronnes",
          "text": "Les facettes sont de fines pellicules de céramique collées sur la face avant de dents intactes et nécessitent peu ou pas de préparation. Les couronnes recouvrent toute la dent et s’utilisent lorsqu’elle est fortement obturée, traitée endodontiquement ou délabrée. La plupart des transformations mélangent les deux : facettes au milieu, couronnes là où une dent a besoin de soutien."
        },
        {
          "name": "Remodelage gingival",
          "text": "Une ligne gingivale irrégulière est redessinée au laser ou à la lame fine. Lorsque les dents elles-mêmes sont courtes parce que la gencive et l’os sont bas, une élongation coronaire est nécessaire — un petit geste chirurgical qui ajoute des semaines au plan, pas des jours."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation au sourire final",
      "steps": [
        {
          "name": "Évaluation et conception",
          "text": "Examen, radiographies, photographies et relevé de teinte. L’occlusion est contrôlée pour rechercher usure et serrement. La conception vous est présentée avec ses limites : quelles dents, quelle quantité d’émail, et quel degré de blancheur reste crédible avec votre peau."
        },
        {
          "name": "Sourire d’essai",
          "text": "Une maquette est collée sur les dents pendant un jour ou deux. C’est le moment d’être exigeant — longueur, symétrie, aspect à la parole — car tout est encore réversible."
        },
        {
          "name": "Préparation",
          "text": "Sous anesthésie locale, l’émail est réduit d’environ l’épaisseur que la céramique ajoutera, des empreintes ou un scan sont réalisés, et des restaurations provisoires sont posées le jour même. Les dents sont généralement sensibles quelques jours."
        },
        {
          "name": "Essayage",
          "text": "La céramique revient du laboratoire et l’adaptation, la teinte et l’occlusion sont vérifiées à sec avant le collage. De petits ajustements sont normaux à ce stade ; une reprise ajouterait des jours."
        },
        {
          "name": "Pose et contrôle",
          "text": "Les restaurations sont collées, l’occlusion affinée, et une gouttière nocturne est réalisée si vous serrez les dents. Contrôle à une ou deux semaines, puis nettoyage de routine — ce sont les marges qui font vivre ces restaurations."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Ce n’est pas une opération mais une série de décisions définitives. Voici celles à connaître avant de préparer la première dent.",
      "items": [
        "L’émail retiré pour les facettes ne repousse pas ; ces dents auront toujours besoin d’une restauration",
        "Sensibilité au chaud et au froid pendant des jours ou des semaines, parfois plus",
        "Ébréchure ou décollement, le plus souvent chez les personnes qui serrent les dents ou rongent leurs ongles",
        "Une teinte qui paraît trop opaque ou trop uniforme, surtout lorsque de nombreuses dents sont traitées en même temps",
        "Inflammation ou récession gingivale au niveau des marges, là où le nettoyage devient difficile"
      ],
      "note": "La déception habituelle ne vient pas de la céramique mais du plan — trop de dents, une teinte trop blanche, ou une occlusion laissée déséquilibrée de sorte que les dents antérieures portent une charge pour laquelle elles n’ont jamais été conçues."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de temps cela prend-il ?",
          "a": "Cinq à sept jours à la clinique pour un cas simple : deux visites pour la préparation et la pose, avec le laboratoire qui travaille entre les deux. Si une chirurgie gingivale, une reconstruction occlusale ou des extractions sont nécessaires, le plan s’étale sur des semaines ou des mois."
        },
        {
          "q": "Cela paraîtra-t-il naturel ?",
          "a": "Cela le peut, mais le naturel est une décision plutôt qu’un réglage par défaut. Les dents réelles n’ont pas une couleur uniforme : le collet est plus chaud, le bord plus translucide, la surface texturée. Un bon céramiste reproduit cela ; un jeu très blanc et très opaque sonne faux quelle que soit la céramique utilisée."
        },
        {
          "q": "Faut-il traiter toutes mes dents ?",
          "a": "Généralement huit à dix dents supérieures, celles qui se voient quand vous souriez et parlez. Les dents inférieures sont souvent laissées telles quelles à moins qu’elles ne se voient. Traiter plus que le visible ajoute du coût et de la perte d’émail sans changer le sourire."
        },
        {
          "q": "Combien de temps durent-elles ?",
          "a": "Des facettes bien réalisées durent couramment dix à quinze ans ; les couronnes de même ou plus longtemps. La durée dépend moins de la céramique que de l’occlusion, du serrement et du soin apporté au nettoyage des marges."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez des photos de votre sourire",
      "text": "Une vue de face, une vue rapprochée des dents et une avec les lèvres au repos suffisent pour un premier avis sur ce qui est possible, environ combien de dents sont concernées et ce que cela demanderait.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen des dents, des gencives, de l’occlusion et de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Hollywood Smile à Istanbul | Clinique Platinya",
    "seoDesc": "Hollywood Smile à Istanbul : facettes, couronnes et remodelage gingival conçus ensemble, généralement en cinq à sept jours pendant votre séjour."
  },
  "/dental-veneers": {
    "title": "Facettes en porcelaine (E-max) à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "Une facette est une fine pellicule de céramique collée sur la face avant d’une dent. L’objectif est de modifier la forme et la couleur en retirant le moins d’émail possible — sur une dent préparée de façon minimale, environ 0,3 à 0,8 mm, et l’émail ne repousse pas.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de facettes en porcelaine à la clinique Platinya",
    "stats": [
      {
        "value": "2 visites",
        "label": "À la clinique"
      },
      {
        "value": "0,3–0,8 mm",
        "label": "Émail généralement retiré"
      },
      {
        "value": "10 ans et +",
        "label": "Durée de vie typique"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Les facettes résolvent des problèmes de forme, de couleur et de position des dents antérieures. Elles ne règlent pas un problème d’occlusion et ne redressent pas un encombrement aussi bien que l’orthodontie.",
      "items": [
        "Dents antérieures ébréchées, usées ou légèrement pivotées, lorsque la modification souhaitée est esthétique",
        "Coloration interne de la dent — fluorose, anciennes taches à la tétracycline, dent traitée endodontiquement — que l’éclaircissement ne peut pas corriger",
        "Petits espaces et bords irréguliers ; un diastème médian isolé peut souvent être fermé",
        "Un émail sain : une facette a besoin d’un support sain pour adhérer"
      ],
      "note": "En cas d’encombrement important, l’orthodontie préalable est généralement le meilleur plan : moins de dents sont mutilées et le résultat dure plus longtemps. Des facettes posées sur des dents encombrées finissent épaisses, opaques et difficiles à nettoyer."
    },
    "techniques": {
      "heading": "Quelle céramique, et pourquoi",
      "intro": "Le matériau est choisi selon la quantité de dent manquante, la quantité d’émail conservable et selon qu’il s’agit d’une dent ou d’un sourire complet.",
      "items": [
        {
          "name": "E-max — disilicate de lithium",
          "text": "Le choix par défaut pour la plupart des facettes : disilicate de lithium pressé ou usiné, collé au ciment résine. Assez résistant pour les dents antérieures et les prémolaires, assez translucide pour se comporter comme l’émail, et il demande environ 0,3 à 0,8 mm de réduction plutôt qu’une couronne complète."
        },
        {
          "name": "Céramique feldspathique",
          "text": "Stratifiée à la main par un céramiste plutôt qu’usinée, de sorte que la couleur et la translucidité sont construites en couches. L’option la plus naturelle pour une dent unique visible ; aussi plus fine, plus exigeante techniquement et plus coûteuse."
        },
        {
          "name": "Collage composite",
          "text": "De la résine construite directement sur la dent, sans retrait d’émail, réalisée en une visite et réversible. Elle se tache et s’ébrèche plus vite — cinq à sept ans est réaliste — elle convient donc aux petites réparations ou à un essai de la forme avant de passer à la céramique."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation aux facettes collées",
      "steps": [
        {
          "name": "Évaluation",
          "text": "Photographies, radiographies, teinte et occlusion. La première question est de savoir si l’orthodontie donnerait un meilleur résultat ; la seconde est la quantité d’émail disponible."
        },
        {
          "name": "Préparation",
          "text": "Sous anesthésie locale, l’émail est réduit de l’épaisseur de la céramique prévue, une empreinte optique est réalisée, et des facettes provisoires sont posées pour que les dents ne restent ni exposées ni sensibles."
        },
        {
          "name": "Essayage",
          "text": "La céramique est essayée avec une pâte hydrosoluble avant tout collage. L’adaptation, la couleur et la forme sont vérifiées à la lumière du jour, pas seulement sous la lumière du fauteuil."
        },
        {
          "name": "Collage",
          "text": "Sous champ opératoire, l’émail est mordancé, la facette est collée au ciment résine, l’excédent est éliminé des marges et l’occlusion est affinée. Cette étape n’est pas réversible."
        },
        {
          "name": "Contrôle et entretien",
          "text": "Un contrôle à une ou deux semaines, une gouttière nocturne si vous serrez les dents, et des consignes de nettoyage incluant le fil dentaire au niveau de la marge. Les ongles, la glace et les capuchons de stylo sont ce qui casse les facettes."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "L’intervention est modeste, mais l’échange est définitif. Voici les limites qu’il faut comprendre avant de préparer la première dent.",
      "items": [
        "La perte d’émail est définitive : la dent aura toujours besoin d’une facette, d’une couronne ou d’un composite",
        "Sensibilité au froid, parfois pendant des semaines, surtout sur les préparations fines",
        "Décollement ou ébréchure, généralement réparables — mais une réparation composite ne s’accorde jamais parfaitement",
        "Une facette isolée est difficile à assortir aux dents voisines des années plus tard, lorsque celles-ci ont vieilli ou changé de teinte",
        "Récession gingivale au niveau de la marge exposant le bord, ou inflammation pulpaire si la préparation est trop agressive"
      ],
      "note": "Le meilleur argument en faveur d’une préparation conservatrice ne concerne pas les cinq premières années mais le troisième remplacement : chaque reprise retire un peu plus de dent, et il existe une limite à ce qui peut être enlevé."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Quelle quantité de dent est retirée ?",
          "a": "Entre 0,3 et 0,8 mm pour une facette E-max typique, et parfois aucune lorsque la dent est déjà usée. Le chiffre est déterminé par l’épaisseur nécessaire à la céramique pour être résistante et par le déplacement visuel souhaité."
        },
        {
          "q": "Les facettes se tachent-elles ?",
          "a": "La céramique elle-même n’absorbe pas la couleur comme la résine. Ce qui change, c’est la marge : si la jonction avec la dent est exposée ou mal nettoyée, elle fonce. Le polissage lors des visites de routine la garde propre."
        },
        {
          "q": "Vont-elles paraître épaisses ?",
          "a": "Seulement si l’on ajoute trop de matière. Une facette peut allonger ou élargir une dent, mais elle ne peut pas la rendre plus fine que la dent ne l’est déjà : une dent proéminente nécessite donc une préparation plutôt que plus de céramique. Cela se décide à l’étape de conception, pas après le collage."
        },
        {
          "q": "Combien de temps durent-elles ?",
          "a": "Dix ans et souvent plus pour des facettes bien réalisées et bien entretenues. Les échecs sont généralement des ébréchures au bord incisif ou des infiltrations à la marge, plus fréquentes chez les personnes qui serrent ou grimpent les dents sans gouttière."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez une photo de la dent que vous voulez modifier",
      "text": "Une photo rapprochée et nette et une vue de face suffisent pour dire si une facette, un collage ou l’orthodontie est la voie la plus raisonnable, et ce que la préparation coûterait en émail.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen des dents, des gencives, de l’occlusion et de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Facettes en porcelaine à Istanbul (E-max) | Platinya",
    "seoDesc": "Facettes en porcelaine à Istanbul : E-max à préparation minimale, teinte et forme choisies avec vous. Ce que signifie le retrait d’émail à long terme."
  },
  "/teeth-whitening": {
    "title": "Blanchiment des dents à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "Le blanchiment modifie la couleur des dents naturelles grâce au peroxyde — au fauteuil à concentration contrôlée, ou à domicile dans une gouttière sur mesure pendant deux à quatre semaines. Il ne change pas la couleur des couronnes, des facettes ni des obturations, et cette limite façonne tout le plan.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Évaluation pour un blanchiment dentaire à la clinique Platinya",
    "stats": [
      {
        "value": "45–90 min",
        "label": "Séance au fauteuil"
      },
      {
        "value": "1–2 séances",
        "label": "Généralement suffisant"
      },
      {
        "value": "6–24 mois",
        "label": "Avant une retouche"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "La plupart des dents adultes saines répondent dans une certaine mesure. Ce qui varie, c’est le type de coloration, la teinte de départ et le fait que la couleur se situe dans l’émail ou plus profondément dans la dent.",
      "items": [
        "Des dents naturelles jaunes ou grisâtres, généralement liées à l’âge ou au thé, au café et au tabac",
        "Une coloration qui revient peu après un détartrage et un polissage professionnels",
        "Avant des facettes ou des couronnes, afin d’assortir la céramique à une teinte plus claire plutôt que l’inverse",
        "Des gencives saines et aucune carie non traitée : blanchir sur une obturation qui fuit ou une dentine exposée donne de la douleur, pas de la blancheur"
      ],
      "note": "Les couronnes, facettes, obturations composites et collages ne s’éclaircissent pas. Blanchir une bouche comportant des restaurations visibles peut les faire paraître plus foncées par contraste ; soit elles sont remplacées ensuite, soit la teinte est assortie à elles."
    },
    "techniques": {
      "heading": "Au fauteuil, à domicile, ou les deux",
      "intro": "Les deux approches utilisent la même chimie à des concentrations différentes. Celle qui vous convient dépend du temps dont vous disposez et de la réaction de vos dents.",
      "items": [
        {
          "name": "Blanchiment au fauteuil",
          "text": "Un gel de peroxyde d’hydrogène à forte concentration — typiquement 25 à 40 % — appliqué avec les gencives isolées et les lèvres écartées, en trois ou quatre cycles de 10 à 15 minutes. Une visite, un résultat rapide ; la sensibilité atteint généralement son maximum le lendemain."
        },
        {
          "name": "Blanchiment à domicile en gouttière sur mesure",
          "text": "Des empreintes sont prises et des gouttières fabriquées sur mesure. Du peroxyde de carbamide à 10–16 % est porté 30 à 60 minutes par jour, ou un gel plus faible la nuit, pendant deux à quatre semaines. Plus lent et plus doux, et le résultat est souvent plus régulier car le gel atteint toute l’arcade."
        },
        {
          "name": "Associé",
          "text": "Une séance au fauteuil pour relever la teinte de base, puis des gouttières à domicile pendant une à deux semaines pour égaliser le collet, qui est généralement la partie la plus foncée. C’est le plan que la plupart des patients finissent par suivre."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la teinte finale",
      "steps": [
        {
          "name": "Évaluation et nettoyage",
          "text": "Les caries, la santé gingivale et les restaurations existantes sont contrôlées. Le détartrage et le polissage viennent d’abord : le blanchiment n’élimine pas le tartre, et une surface propre est le seul point de départ juste."
        },
        {
          "name": "Relevé de teinte",
          "text": "Des photographies et une lecture de teinte sous lumière normalisée, prises avant de commencer. Sans cela, le changement ne peut être discuté, pas mesuré."
        },
        {
          "name": "Blanchiment",
          "text": "Soit une séance unique au fauteuil avec isolation gingivale, soit des gouttières et des consignes écrites. Avec les gouttières, les deux ou trois premiers jours montrent si vos dents sont sensibles et la force du gel est ajustée en conséquence."
        },
        {
          "name": "Contrôle à deux semaines",
          "text": "La couleur se stabilise en environ deux semaines à mesure que les dents se réhydratent : la teinte finale s’apprécie donc à ce moment-là — pas le jour du traitement, où les dents paraissent toujours anormalement brillantes."
        },
        {
          "name": "Entretien",
          "text": "Des gouttières de retouche tous les six à vingt-quatre mois, et 48 heures de bon sens : pas de café, de vin rouge, de curcuma ni de tabac pendant que l’émail est le plus réceptif."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Le blanchiment est peu risqué lorsqu’il est évalué et encadré. La plupart des problèmes viennent de sa réalisation sans l’un ou l’autre.",
      "items": [
        "Sensibilité pendant le traitement et un jour ou deux après, parfois plus longtemps ; une récession gingivale préexistante l’aggrave",
        "Irritation ou blanchiment gingival là où le gel atteint les tissus mous — généralement transitoire et résolutif en quelques jours",
        "Peu ou pas de changement sur les colorations internes, une dent traitée endodontiquement ou une fluorose",
        "Les restaurations gardent leur teinte d’origine et peuvent paraître plus foncées une fois les dents voisines éclaircies",
        "Récidive : le résultat n’est pas définitif, et la vitesse d’estompage dépend de l’alimentation et du tabac"
      ],
      "note": "Plus de gel ne signifie pas plus blanc. Des séances fortes répétées sans contrôle augmentent la sensibilité et donnent à l’émail un aspect crayeux et fin ; les consignes de gouttière existent pour une raison."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Cela abîme-t-il l’émail ?",
          "a": "À des concentrations encadrées, non : le peroxyde retire les pigments sans dissoudre de structure dentaire mesurable, et le minéral se reconstitue dans les jours suivants. Les dommages et la sensibilité durable viennent d’un usage abusif — séances fortes fréquentes sans évaluation."
        },
        {
          "q": "Jusqu’à quel point mes dents vont-elles blanchir ?",
          "a": "Cela ne peut pas être promis à l’avance. Les colorations jaunes et liées à l’âge répondent le mieux ; les colorations grises, liées à la tétracycline et les fluoroses répondent mal et parfois pas du tout. La plupart des patients gagnent quelques teintes, et la réponse honnête est une fourchette plutôt qu’un chiffre."
        },
        {
          "q": "Est-ce douloureux ?",
          "a": "Le gel lui-même n’est pas douloureux. Une sensibilité au froid, et parfois une douleur vive au collet, est fréquente pendant un jour ou deux — réduite par une concentration plus faible, un temps de port plus court ou un gel désensibilisant avant la séance."
        },
        {
          "q": "Combien de temps cela dure-t-il ?",
          "a": "De six mois à deux ans pour la plupart des personnes. Le café, le thé, le vin rouge, le curcuma et le tabac accélèrent le retour ; une visite d’hygiène tous les six mois et une gouttière de retouche occasionnelle le maintiennent."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez une photo à la lumière du jour",
      "text": "Une photographie prise près d’une fenêtre, sans filtre, suffit généralement pour dire quel type de coloration vous avez, si le blanchiment a des chances de fonctionner et si des restaurations doivent être prévues autour.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen des dents et des gencives et revue de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Blanchiment des dents à Istanbul | Clinique Platinya",
    "seoDesc": "Blanchiment dentaire à Istanbul : au fauteuil ou à domicile, teintes attendues, et pourquoi couronnes et obturations ne blanchissent pas."
  },
  "/dental-implants": {
    "title": "Implants dentaires à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "Un implant est une vis en titane placée dans l’os de la mâchoire ; en trois à six mois, l’os se développe autour, puis une couronne, un bridge ou une arcade complète est fixé dessus. Il remplace la racine, ce qui explique qu’il ne dépende pas des dents voisines.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation d’implants dentaires à la clinique Platinya",
    "stats": [
      {
        "value": "3–6 mois",
        "label": "Cicatrisation osseuse avant la couronne"
      },
      {
        "value": "45–90 min",
        "label": "Pose d’un implant unique"
      },
      {
        "value": "10–15 ans et +",
        "label": "Fonction avec entretien"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Les facteurs décisifs sont la quantité d’os disponible, sa qualité, l’état des gencives et le contrôle de toute maladie générale.",
      "items": [
        "Une dent manquante, avec des dents voisines saines qu’il ne faut pas mutiler pour un bridge",
        "Plusieurs dents manquantes dans la même arcade, ou une arcade complète mobile ou devenue inutilisable",
        "Suffisamment d’os — ou un os reconstructible par greffe ou par élévation sinusienne",
        "Un diabète équilibré, l’absence de tabac ou la volonté d’arrêter, et aucune radiothérapie ni traitement antirésorptif récent au niveau de la mâchoire"
      ],
      "note": "Le tabac est le facteur le plus utile à modifier : il double environ le risque d’échec d’ostéo-intégration, et l’effet dépend de la quantité fumée. Un diabète non équilibré altère la cicatrisation de façon comparable."
    },
    "techniques": {
      "heading": "Une dent, plusieurs dents, ou une arcade complète",
      "intro": "Le nombre et la position des implants sont déterminés par l’os présent et par la façon dont l’occlusion le charge — pas par le nombre de dents manquantes.",
      "items": [
        {
          "name": "Implant unique et couronne",
          "text": "Le remplacement le plus conservateur d’une dent manquante : rien n’est retiré aux dents voisines. La pose dure 45 à 90 minutes sous anesthésie locale, suivie de trois à six mois de cicatrisation avant la fabrication de la couronne."
        },
        {
          "name": "Bridge sur implants",
          "text": "Pour plusieurs dents manquantes consécutives, deux implants ou plus portent un bridge, et les dents situées aux extrémités restent intactes. Moins d’implants que de dents remplacées — c’est pourquoi la travée doit être planifiée avec soin, et non allongée pour économiser une vis."
        },
        {
          "name": "All-on-4 et All-on-6",
          "text": "Une arcade complète fixée sur quatre ou six implants, les postérieurs étant inclinés pour utiliser l’os restant et souvent éviter une greffe. Un bridge provisoire peut généralement être posé en quelques jours ; le définitif attend la cicatrisation. Tout le monde n’y est pas éligible — le volume osseux, l’occlusion et le soutien de la lèvre décident."
        }
      ]
    },
    "journey": {
      "heading": "Du scanner à la couronne définitive",
      "steps": [
        {
          "name": "Évaluation et planification",
          "text": "Un scanner CBCT mesure la hauteur et la largeur osseuses et montre où se trouvent le nerf et le sinus. Si l’os est fin, une greffe ou une élévation sinusienne est planifiée d’abord, ce qui ajoute quatre à six mois avant la pose de l’implant."
        },
        {
          "name": "La pose",
          "text": "Sous anesthésie locale, 45 à 90 minutes pour un implant unique. La stabilité est enregistrée, et la dent ou la prothèse provisoire est ajustée pour ne pas charger l’implant pendant la cicatrisation."
        },
        {
          "name": "Ostéo-intégration",
          "text": "Trois à six mois pendant lesquels l’implant est laissé tranquille. La mâchoire inférieure est généralement prête plus tôt que la supérieure, et les sites greffés demandent plus de temps. Le tabac et un diabète mal équilibré ralentissent cette phase."
        },
        {
          "name": "Pilier et empreinte",
          "text": "La gencive est façonnée autour d’un pilier de cicatrisation, puis un scan ou une empreinte est réalisé et la couronne ou le bridge est fabriqué — généralement une à trois semaines au laboratoire."
        },
        {
          "name": "Pose et entretien",
          "text": "La restauration est vissée ou scellée en place et l’occlusion est vérifiée. Visites d’hygiène tous les six mois, avec une radiographie à un an puis périodiquement : la perte osseuse autour d’un implant est silencieuse jusqu’à un stade avancé."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "La chirurgie implantaire est courante, mais elle reste une chirurgie dans l’os, avec des modes d’échec spécifiques. Voici ceux qui comptent.",
      "items": [
        "Absence d’ostéo-intégration : l’implant se mobilise et doit être retiré — plus probable chez les fumeurs, en cas d’os fin et de diabète non équilibré",
        "Péri-implantite, perte osseuse autour d’un implant en fonction, généralement liée à la plaque ; elle ne régresse pas spontanément",
        "Lésion nerveuse à la mâchoire inférieure entraînant une insensibilité de la lèvre, du menton ou de la langue — généralement temporaire, parfois définitive",
        "Perforation sinusienne ou échec de greffe à la mâchoire supérieure, pouvant nécessiter une seconde intervention",
        "Fracture d’un composant, vis desserrée ou couronne ébréchée — réparable, mais pas gratuit"
      ],
      "note": "Un implant n’est pas une dent. Il n’a pas de ligament, donne moins de sensations lorsque vous mordez trop fort, et une fois l’os perdu autour de lui, il ne repousse pas. L’hygiène et une gouttière nocturne comptent plus que la marque sur la boîte."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "L’intervention est-elle douloureuse ?",
          "a": "Sous anesthésie locale, vous ressentez une pression et des vibrations plutôt que de la douleur. Les deux premiers jours sont marqués par des contusions et un œdème, et du paracétamol ou de l’ibuprofène suffisent généralement ; la plupart des personnes reprennent le travail de bureau le lendemain."
        },
        {
          "q": "Combien de temps prend l’ensemble ?",
          "a": "Quatre à huit mois entre la pose et la couronne définitive pour un implant unique, car l’os impose son calendrier. Une arcade complète en All-on-4 peut recevoir un provisoire fixe en quelques jours, avec le bridge définitif à quatre à six mois."
        },
        {
          "q": "Puis-je fumer ?",
          "a": "Idéalement pas du tout pendant le traitement. Arrêter au moins une semaine avant la pose et pendant environ huit semaines après améliore nettement les chances d’ostéo-intégration ; fumer ensuite augmente le risque à long terme de perte osseuse autour de l’implant."
        },
        {
          "q": "Et si je n’ai pas assez d’os ?",
          "a": "L’os peut être reconstruit — greffe particulaire avec membrane pour la largeur, greffe en bloc pour les défauts plus importants, ou élévation sinusienne pour le secteur postérieur supérieur. C’est une procédure distincte avec son propre temps de cicatrisation, planifiée à partir du scanner plutôt que découverte pendant l’intervention."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez votre panoramique dentaire",
      "text": "Un panoramique récent ou un CBCT, accompagné d’une note indiquant les dents manquantes, suffit pour dire si une greffe est probable, environ combien d’implants et combien de temps durerait le plan.",
      "button": "Envoyer votre radiographie"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen de la bouche, lecture d’un scanner CBCT et revue de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Implants dentaires à Istanbul | Clinique Platinya",
    "seoDesc": "Implants dentaires à Istanbul : implants en titane, greffe osseuse si nécessaire et cicatrisation de trois à six mois avant la couronne définitive."
  },
  "/zircon-teeth": {
    "title": "Couronnes en zircone à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "Une couronne en zircone est usinée dans un bloc de dioxyde de zirconium puis frittée jusqu’à durcissement. Elle s’utilise là où une couronne métal-céramique laisserait une ligne grise au niveau de la gencive, et elle est assez résistante pour les dents postérieures comme pour les antérieures.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation pour une couronne en zircone à la clinique Platinya",
    "stats": [
      {
        "value": "2 visites",
        "label": "À la clinique"
      },
      {
        "value": "5–7 jours",
        "label": "Temps de laboratoire"
      },
      {
        "value": "10–15 ans",
        "label": "Durée de vie typique"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "La zircone est choisie pour sa résistance, pour l’esthétique sans métal, ou les deux. Elle n’est pas automatiquement meilleure qu’une couronne métal-céramique bien réalisée — elle est différente.",
      "items": [
        "Dents fortement obturées, traitées endodontiquement ou fissurées, nécessitant une couverture complète",
        "Dents postérieures soumises à de fortes charges, où une couronne céramo-céramique fine s’ébrécherait",
        "Dents antérieures visibles où la ligne gingivale doit rester exempte de métal",
        "Une sensibilité connue aux métaux, ou une couronne métal-céramique existante dont la marge sombre se voit"
      ],
      "note": "Une couronne a besoin de suffisamment de dent pour tenir. S’il reste très peu de dent au-dessus de la gencive, la dent peut nécessiter d’abord une reconstitution par inlay-core ou une élongation coronaire ; une couronne ne remplace pas indéfiniment la structure dentaire manquante."
    },
    "techniques": {
      "heading": "Monolithique ou stratifiée",
      "intro": "Les deux sont en zircone. La différence tient au fait que toute la couronne est dans le même matériau ou qu’il s’agit d’une chape résistante recouverte de porcelaine, et cela décide de son aspect comme de son mode d’échec.",
      "items": [
        {
          "name": "Zircone monolithique",
          "text": "La couronne entière est en zircone usinée, frittée et polie. L’option la plus résistante pour les molaires et pour les personnes qui serrent les dents ; moins translucide que la céramique stratifiée, elle peut donc paraître plate sur une dent antérieure si la teinte et la texture de surface ne sont pas travaillées avec soin."
        },
        {
          "name": "Zircone stratifiée",
          "text": "Une chape en zircone recouverte de porcelaine. Meilleure à l’avant, où la lumière doit traverser la dent, mais la porcelaine de recouvrement peut s’ébrécher — c’est l’échec habituel de ce design. Un compromis raisonnable sur les prémolaires et les dents visibles."
        },
        {
          "name": "Métal-céramique, pour comparaison",
          "text": "Une chape métallique avec de la porcelaine fondue dessus : prévisible, moins coûteuse et très éprouvée. Sa faiblesse est esthétique — une chape opaque et, au fil des années, une ligne grise là où la gencive se rétracte de la marge métallique."
        }
      ]
    },
    "journey": {
      "heading": "De la préparation à la couronne scellée",
      "steps": [
        {
          "name": "Évaluation",
          "text": "La raison pour laquelle la dent a besoin d’une couronne est établie d’abord : une fissure, une grande obturation ancienne, un traitement endodontique. La quantité de dent restant au-dessus de la gencive détermine si une couronne suffit."
        },
        {
          "name": "Préparation",
          "text": "Sous anesthésie locale, la dent est réduite de 1 à 1,5 mm, davantage là où de la porcelaine sera stratifiée. Un scan ou une empreinte est réalisé et une couronne provisoire posée pour protéger la dent et éviter qu’elle ne bouge."
        },
        {
          "name": "Conception et usinage",
          "text": "La couronne est conçue en CFAO, usinée dans le bloc de zircone et frittée à haute température, puis teintée et glacée. C’est là que la teinte se fixe — une prise de teinte faite sous la lumière du fauteuil paraîtra fausse à la lumière du jour."
        },
        {
          "name": "Essayage et scellement",
          "text": "L’adaptation, les points de contact et la teinte sont vérifiés avant le scellement. La couronne est ensuite posée au ciment résine ou verre-ionomère et l’occlusion est affinée jusqu’à ce que les contacts soient réguliers."
        },
        {
          "name": "Contrôle",
          "text": "Un contrôle à une ou deux semaines, surtout pour l’occlusion. En cas de signes de serrement, une gouttière nocturne est réalisée — une couronne protège une dent, elle ne se protège pas elle-même d’une occlusion lourde."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "La zircone est résistante, mais une couronne est une restauration sur une dent qui a déjà échoué une fois. Voici les problèmes réalistes.",
      "items": [
        "La couronne peut se desceller si le pilier est court ou si le ciment est compromis — généralement reprenable",
        "Ébréchure de la porcelaine stratifiée, le plus souvent sur une couronne fine ou soumise à une occlusion lourde",
        "La zircone est plus dure que l’émail et peut user la dent antagoniste au fil des ans, surtout si la surface reste non polie",
        "Une couronne monolithique peut paraître opaque ou trop uniforme à l’avant, en particulier sous forte lumière",
        "Inflammation pulpaire, ou nécessité d’un traitement endodontique, après préparation d’une dent déjà compromise"
      ],
      "note": "Une couronne ne vaut que ce que vaut ce qu’il y a dessous. Si la dent est fissurée sous la gencive ou s’il reste très peu de structure, l’option honnête peut être l’extraction et un implant plutôt qu’une troisième couronne sur la même dent."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Est-ce meilleur que le métal-céramique ?",
          "a": "Au niveau de la gencive, oui : il n’y a pas de collier métallique, donc pas de ligne grise à mesure que la gencive se rétracte. Pour la couleur et la translucidité, une céramique bien stratifiée peut encore mieux faire. La zircone monolithique gagne sur la résistance, pas sur le réalisme."
        },
        {
          "q": "La zircone casse-t-elle ?",
          "a": "Une couronne monolithique casse rarement d’un bloc — c’est la couronne céramique la plus résistante en usage courant. L’échec fréquent est l’ébréchure de la couche de porcelaine sur une couronne stratifiée, réparable mais pas invisible."
        },
        {
          "q": "Peut-on l’utiliser sur les dents postérieures ?",
          "a": "Oui — c’est son principal avantage. Les molaires subissent les charges les plus lourdes, et la zircone les supporte mieux que la céramo-céramique. Pour une deuxième molaire, une couronne monolithique est généralement le choix raisonnable."
        },
        {
          "q": "Combien de temps durera-t-elle ?",
          "a": "Dix à quinze ans est une attente raisonnable, parfois plus. La limite est rarement la zircone elle-même : c’est la dent dessous, la marge gingivale et le contrôle de l’occlusion."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez une photo de la dent",
      "text": "Une photographie rapprochée et une radiographie de la dent suffisent pour dire si une couronne en zircone, un inlay-core ou une extraction est la réparation la plus raisonnable — et pourquoi.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après examen de la dent, des gencives et de l’occlusion, et revue de l’historique médical ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Couronnes en zircone à Istanbul | Clinique Platinya",
    "seoDesc": "Couronnes en zircone à Istanbul : résistance, couleur et absence de ligne grise gingivale. Comparaison honnête avec les couronnes métal-céramique."
  },
  "/periodontics": {
    "title": "Traitement des gencives (parodontologie) à Istanbul",
    "eyebrow": "Soins dentaires",
    "lead": "La maladie parodontale commence par une inflammation qui saigne au brossage et peut finir par des dents mobiles puis perdues. Le traitement retire le dépôt bactérien de la surface radiculaire et le maintient à distance. La maladie est contrôlée, pas guérie.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Examen parodontal à la clinique Platinya",
    "stats": [
      {
        "value": "1–4 séances",
        "label": "Détartrage et surfaçage radiculaire"
      },
      {
        "value": "6–8 semaines",
        "label": "Avant la réévaluation"
      },
      {
        "value": "3–6 mois",
        "label": "Intervalle de maintenance"
      }
    ],
    "candidate": {
      "heading": "Qui a besoin d’un traitement",
      "intro": "Presque toute personne dont les gencives saignent est candidate à un traitement initial. Ce qui modifie le plan, c’est la profondeur des poches et la quantité d’os déjà perdue.",
      "items": [
        "Saignement au brossage ou au fil dentaire, même sans douleur",
        "Mauvaise haleine persistante ou goût métallique, avec du tartre visible au niveau de la gencive",
        "Des gencives qui se sont rétractées, ou des dents qui paraissent plus longues qu’avant",
        "Des poches supérieures à 4 mm au sondage, ou des dents qui ont commencé à bouger"
      ],
      "note": "Le tabac masque les signes : il contracte les vaisseaux, donc les gencives saignent moins alors que la maladie continue. Le diabète et la grossesse modifient aussi la réponse, c’est pourquoi les deux sont demandés."
    },
    "techniques": {
      "heading": "Nettoyage, chirurgie ou greffe",
      "intro": "Presque tous les cas commencent par la même étape — retirer ce qui se trouve sur la racine. Le reste se décide selon ce que fait le tissu ensuite.",
      "items": [
        {
          "name": "Détartrage et surfaçage radiculaire",
          "text": "Un nettoyage profond sous anesthésie locale, généralement quadrant par quadrant, retirant le tartre et les dépôts bactériens sous la gencive. C’est le traitement de la plupart des cas ; la chirurgie n’est envisagée que si les poches restent profondes ensuite."
        },
        {
          "name": "Curetage et chirurgie à lambeau",
          "text": "Lorsque des poches restent profondes après le traitement initial, la gencive est soulevée, les surfaces radiculaires nettoyées sous vision directe et le tissu repositionné. On la réserve aux sites qui n’ont pas répondu — ce n’est pas une première étape."
        },
        {
          "name": "Greffe gingivale pour récession",
          "text": "Lorsqu’une racine est exposée, sensible, ou que la récession progresse, du tissu est prélevé au palais et greffé sur la racine. Cela recouvre la racine et épaissit la gencive ; cela ne reconstitue pas l’os déjà perdu."
        }
      ]
    },
    "journey": {
      "heading": "Du bilan à la maintenance",
      "steps": [
        {
          "name": "Bilan parodontal",
          "text": "Profondeur de sondage autour de chaque dent, scores de saignement, mobilité et radiographies pour le niveau osseux. C’est ce relevé qui rend le changement mesurable plus tard — sans lui, le traitement se juge à l’impression."
        },
        {
          "name": "Traitement initial",
          "text": "Détartrage et surfaçage radiculaire sur une à quatre séances, espacées d’une à deux semaines, avec anesthésie locale là où les poches sont profondes. La technique de brossage est corrigée en même temps, car le nettoyage n’achète qu’un nouveau départ."
        },
        {
          "name": "Réévaluation à six à huit semaines",
          "text": "Les poches sont mesurées à nouveau. Les poches peu profondes s’améliorent souvent d’un ou deux millimètres ; les profondes souvent pas, et ce sont ces sites qui demandent une décision."
        },
        {
          "name": "Chirurgie, si nécessaire",
          "text": "Planifiée uniquement pour les sites qui n’ont pas répondu, et seulement après la réévaluation. C’est un geste plus modeste qu’il n’y paraît, mais c’est de la chirurgie, avec son propre temps de cicatrisation."
        },
        {
          "name": "Maintenance",
          "text": "Des visites tous les trois à six mois, avec un nouveau sondage. C’est l’étape qui décide de la conservation des dents : la maladie revient partout où le biofilm est laissé se reconstruire sans perturbation."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Ce que les patients appellent souvent une complication est en fait la cicatrisation des tissus. Les vrais risques sont différents, et méritent d’être énoncés clairement.",
      "items": [
        "Les gencives se rétractent à mesure que l’inflammation diminue : les dents paraissent plus longues et les racines peuvent s’exposer — c’est de la cicatrisation, pas un dommage",
        "Sensibilité au froid sur les racines exposées, parfois pendant des semaines",
        "Saignement et sensibilité pendant quelques jours après un nettoyage profond, et gêne à la mastication",
        "La maladie est chronique : sans maintenance, elle revient, et l’os déjà perdu ne repousse pas",
        "Dans les cas avancés, des dents peuvent encore être perdues ; l’objectif est de conserver les autres, pas de promettre chaque dent"
      ],
      "note": "Le tabac est le facteur le plus important que vous pouvez modifier : il émousse la réponse au traitement et masque le saignement qui vous aurait amené plus tôt. L’arrêt change le pronostic plus que n’importe quel bain de bouche."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Le nettoyage profond va-t-il déchausser mes dents ?",
          "a": "Non. Les dents peuvent sembler mobiles quelques jours parce que le tartre qui les calait a disparu et que l’œdème s’est résorbé ; elles se raffermissent à mesure que le tissu cicatrise. Lorsque la perte osseuse est avancée, la dent était déjà mobile avant le traitement."
        },
        {
          "q": "Est-ce une guérison ?",
          "a": "Non — c’est un contrôle. La parodontite ne disparaît pas, mais elle peut être stabilisée. La maintenance tous les trois à six mois est ce qui la maintient stable, et la négliger est la raison la plus fréquente de perte de dents plus tard."
        },
        {
          "q": "Est-ce douloureux ?",
          "a": "Le nettoyage se fait sous anesthésie locale, donc pas pendant. Ensuite les gencives sont sensibles deux ou trois jours et les racines peuvent réagir au froid pendant quelques semaines ; les deux se calment avec des antalgiques ordinaires et un dentifrice désensibilisant."
        },
        {
          "q": "À quelle fréquence dois-je revenir ?",
          "a": "Tous les trois mois si les poches étaient profondes, si vous fumez ou si votre diabète est mal équilibré ; tous les six mois pour les cas plus légers. L’intervalle est fixé à la réévaluation, à partir des mesures et non d’une règle."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez une photo de vos gencives",
      "text": "Une photographie de la ligne gingivale et une radiographie récente suffisent pour un premier avis : s’agit-il d’une gingivite, d’une parodontite, ou de quelque chose qui doit être vu au fauteuil.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La maladie parodontale ne peut être diagnostiquée que par sondage et imagerie ; la faisabilité du traitement est jugée après examen, et les résultats varient d’un patient à l’autre.",
    "seoTitle": "Parodontologie (gencives) à Istanbul | Clinique Platinya",
    "seoDesc": "Traitement parodontal à Istanbul : détartrage, nettoyage profond et suivi pour gencives qui saignent et récessions, avant tout travail esthétique."
  },
  "/facelift-surgery": {
    "title": "Lifting facial à Istanbul (lifting deep-plane)",
    "eyebrow": "Chirurgie plastique du visage",
    "lead": "Le lifting facial remonte les tissus mous du visage et du cou qui ont descendu avec l’âge, et retire la peau qui ne leur correspond plus. Il modifie la ligne de la mâchoire et le cou, pas la surface de la peau.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de lifting facial à la clinique Platinya",
    "stats": [
      {
        "value": "2–4 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1–2 nuits",
        "label": "Hospitalisation"
      },
      {
        "value": "2–3 semaines",
        "label": "Arrêt social"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "L’intervention traite le relâchement, pas les rides. Elle convient à une personne dont le poids est stable, dont la peau a encore une certaine élasticité et qui veut paraître elle-même, reposée.",
      "items": [
        "Des bajoues le long de la ligne de la mâchoire, et un pli qui va du nez à la bouche",
        "Un tiers moyen du visage descendu, avec un aplatissement des pommettes",
        "Une peau relâchée et des bandes verticales dans le cou",
        "Un état de santé compatible avec une anesthésie générale, et pas de tabac depuis un mois"
      ],
      "note": "Un lifting facial n’arrête pas le vieillissement : le visage continue de changer au même rythme ensuite. Les ridules, les pigmentations et les dommages solaires se traitent autrement — laser, peelings ou toxine botulique — et sont souvent associés à la chirurgie plutôt que remplacés par elle."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Le plan est établi à partir des tissus, de l’os et du cou — examinés en présentiel, le visage au repos et en mouvement. Une photographie ne montre pas la laxité.",
      "items": [
        {
          "name": "Lifting deep-plane",
          "text": "Les couches profondes du visage sont décollées et remontées comme une seule unité, de sorte que la traction est portée par un tissu solide plutôt que par la peau. Il donne la ligne de mâchoire la plus naturelle et le résultat le plus durable, et c’est la technique utilisée lorsque le tiers moyen est descendu."
        },
        {
          "name": "Lifting SMAS à cicatrice courte",
          "text": "La couche musculaire est resserrée par une incision plus courte, sans décollement profond. Moins de temps opératoire et moins d’œdème, et une bonne option pour un relâchement débutant — mais il traite davantage le bas du visage que le tiers moyen."
        },
        {
          "name": "Lifting du cou (platysmaplastie)",
          "text": "Les muscles du cou sont rapprochés sur la ligne médiane et la peau relâchée est retirée, par une petite incision sous le menton et l’incision derrière l’oreille. C’est souvent la partie de l’intervention que les patients remarquent le plus."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Le visage est examiné assis et allongé, le cou et la ligne d’implantation des cheveux sont évalués, et des photographies sont prises. Des analyses de sang et, si nécessaire, un avis cardiologique sont organisés avant de fixer une date. La cicatrice et sa position sont validées à l’avance."
        },
        {
          "name": "Préparation",
          "text": "Le tabac est arrêté au moins quatre semaines avant l’intervention — c’est le facteur le plus important pour la cicatrisation du visage. Les anticoagulants et certains compléments sont suspendus environ dix jours avant, et vous restez à jeun six à huit heures. Organisez de l’aide à la maison la première semaine."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale, généralement deux à quatre heures. L’incision passe devant et derrière l’oreille et se prolonge dans la ligne d’implantation au niveau de la tempe : elle est donc cachée par l’oreille et par les cheveux. Un drain est souvent laissé de chaque côté pendant un jour ou deux, et la plupart des patients restent une ou deux nuits."
        },
        {
          "name": "Les deux premières semaines",
          "text": "L’œdème et les hématomes atteignent leur maximum vers le deuxième au quatrième jour puis diminuent. La tête est maintenue surélevée, des compresses froides sont utilisées les premiers jours et le drain est retiré à la clinique. La plupart des patients se sentent capables de sortir — avec des lunettes de soleil — après sept à dix jours."
        },
        {
          "name": "Semaines trois à six, et la cicatrice",
          "text": "Le maquillage et la coloration reprennent après environ deux semaines, le sport après quatre à six. La cicatrice est ferme et rosée pendant deux à trois mois, puis s’éclaircit en douze à dix-huit mois ; elle se situe derrière l’oreille et à l’intérieur de la ligne d’implantation chaque fois que possible."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "C’est une vraie chirurgie à proximité du nerf facial, et les risques doivent être entendus avant la décision, pas après.",
      "items": [
        "Hématome — une collection de sang sous la peau ; c’est la complication la plus fréquente, et il peut devoir être drainé",
        "Faiblesse temporaire du nerf facial, qui récupère généralement en quelques semaines à quelques mois ; une atteinte définitive est rare",
        "Troubles de cicatrisation ou perte de peau, bien plus probables chez les fumeurs et en cas de mauvaise circulation",
        "Une cicatrice large ou épaissie, de petites zones de perte de cheveux le long de l’incision, et une insensibilité devant l’oreille qui s’améliore habituellement en quelques mois",
        "Asymétrie, ou un résultat jugé trop tendu ou trop discret, nécessitant une reprise"
      ],
      "note": "Parlez-nous du tabac, du diabète, de la tension artérielle, des anticoagulants et de toute chirurgie ou injection de filler antérieure au visage. Les fillers et les fils modifient l’anatomie et le plan, et les cacher est le chemin le plus rapide vers une opération compliquée."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Vais-je ressembler à quelqu’un d’autre ?",
          "a": "L’objectif est que vous paraissiez vous-même, reposé. Un lifting remonte des tissus qui ont chuté ; il ne change ni la forme du nez, ni les yeux, ni le caractère du visage. Un aspect visiblement opéré vient généralement d’une peau trop tirée, c’est pourquoi ici la tension est portée par les couches profondes."
        },
        {
          "q": "Combien de temps le résultat dure-t-il ?",
          "a": "La plupart des patients constatent le changement pendant sept à dix ans, et souvent plus longtemps pour le cou. Ce n’est pas définitif, car le visage continue de vieillir à son propre rythme. Maintenir un poids stable et protéger la peau du soleil y contribuent."
        },
        {
          "q": "Quand pourrai-je me montrer en public ?",
          "a": "La plupart des personnes sont à l’aise après dix à quatorze jours, avec un œdème résiduel facile à couvrir. Le visage continue de se stabiliser pendant trois à six mois, et la forme finale de la ligne de mâchoire s’apprécie à ce moment-là."
        },
        {
          "q": "Peut-on l’associer à une chirurgie des paupières ?",
          "a": "Souvent oui — une chirurgie des paupières supérieures ou inférieures, un lifting des sourcils ou une greffe de graisse sur les pommettes sont fréquemment réalisés dans la même séance. La sécurité dépend de la durée opératoire totale et de votre état de santé, et cela se décide en consultation."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Trois photographies — face, trois quarts et profil — suffisent à un chirurgien pour dire si un lifting est la bonne opération, et quelle technique conviendrait. Un coordinateur revient vers vous avec un plan, une date et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Lifting facial à Istanbul | Clinique Platinya",
    "seoDesc": "Lifting facial à Istanbul : peau et couche profonde remontées, cicatrices cachées autour de l’oreille. Deux à trois semaines d’arrêt social."
  },
  "/chin-implants": {
    "title": "Augmentation du menton à Istanbul (implant et génioplastie)",
    "eyebrow": "Chirurgie plastique du visage",
    "lead": "Un menton fuyant ou en retrait déséquilibre tout le visage — le nez paraît plus grand, la mâchoire plus douce et le cou plus court. L’augmentation du menton le projette vers l’avant, au moyen d’un implant, en déplaçant l’os, ou temporairement avec un filler.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation d’augmentation du menton à la clinique Platinya",
    "stats": [
      {
        "value": "1–2 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1 nuit",
        "label": "Hospitalisation"
      },
      {
        "value": "1–2 semaines",
        "label": "Œdème visible"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "L’évaluation porte sur les proportions et sur l’occlusion, pas sur le menton seul. Un menton se juge par rapport au nez, aux lèvres et à l’angle de la mâchoire.",
      "items": [
        "Un menton situé en arrière de la ligne de la lèvre inférieure de profil",
        "Une ligne de mâchoire qui paraît douce ou courte de face",
        "Une asymétrie après un traumatisme, ou après une chirurgie maxillo-faciale antérieure",
        "Un menton envisagé en même temps qu’une rhinoplastie, pour garder le profil équilibré"
      ],
      "note": "Si les dents ne s’engrènent pas correctement, le problème de fond est l’occlusion, et un implant ne le corrigera pas. Cela nécessite une évaluation orthodontique et maxillo-faciale, et parfois une chirurgie orthognathique — déplacer la mâchoire elle-même — plutôt qu’un implant posé devant elle."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Trois opérations différentes sont vendues sous le même nom. Elles diffèrent par ce qu’elles déplacent, par leur réversibilité et par leur durée.",
      "items": [
        {
          "name": "Implant de menton en silicone",
          "text": "Un implant souple et solide est placé sur l’os par une petite incision à l’intérieur de la lèvre inférieure, ou parfois sous le menton. Il ajoute de la projection et de la largeur, l’intervention dure environ une heure, et il peut être retiré ou remplacé plus tard. L’implant repose sur l’os et ne fusionne pas avec lui."
        },
        {
          "name": "Génioplastie par glissement",
          "text": "L’os du menton est sectionné, avancé — ou abaissé, ou déplacé latéralement — puis fixé par de petites plaques et vis. On utilise votre propre os : il n’y a donc pas d’implant à déplacer, et cela permet de corriger une hauteur verticale et une asymétrie qu’un implant ne peut pas traiter. Une opération plus lourde, avec plus d’œdème."
        },
        {
          "name": "Filler d’acide hyaluronique",
          "text": "Une option temporaire, réalisée à la clinique en moins d’une heure, sans arrêt d’activité. Elle montre à quoi ressemblerait la projection avant de s’engager dans la chirurgie, et dure environ neuf à dix-huit mois. Elle ne peut pas corriger un os court ou asymétrique."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Des photographies de profil, une mesure du visage et un examen de l’occlusion. Lorsque l’os doit être déplacé, ou que l’occlusion est en cause, une radiographie céphalométrique ou un scanner sont réalisés. La taille et la forme de l’implant sont choisies sur le modèle de votre visage."
        },
        {
          "name": "Préparation",
          "text": "Des analyses de sang, et un contrôle dentaire si l’incision se fait dans la bouche — dents et gencives doivent être saines avant une intervention intra-orale. Le tabac est arrêté quatre semaines avant. Les anticoagulants sont suspendus environ dix jours avant, et vous restez à jeun six à huit heures."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale ou sédation profonde, une à deux heures. L’implant est introduit par une incision à l’intérieur de la lèvre inférieure, sans cicatrice sur la peau ; l’incision est fermée par des fils résorbables. La plupart des patients restent une nuit."
        },
        {
          "name": "La première semaine",
          "text": "L’œdème atteint son maximum entre quarante-huit et soixante-douze heures, et la lèvre inférieure et le menton sont raides et insensibles. Alimentation molle, pas de mastication sur les dents de devant, bain de bouche après chaque repas, et dormir la tête surélevée. Les hématomes peuvent descendre dans le cou et se résorbent en une semaine."
        },
        {
          "name": "Semaines deux à six",
          "text": "L’essentiel de l’œdème a disparu après deux à trois semaines, le reste se résorbe en trois mois. L’insensibilité de la lèvre inférieure s’améliore progressivement, parfois sur plusieurs mois. Le sport de contact et les soins dentaires attendent environ six semaines."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Le menton est proche du nerf mentonnier et l’incision jouxte la bouche : les deux façonnent la liste des risques.",
      "items": [
        "Infection, plus probable avec une incision dans la bouche ; un implant infecté doit généralement être retiré",
        "Sensation altérée de la lèvre inférieure et du menton, par étirement ou contusion du nerf mentonnier — généralement temporaire, parfois définitive",
        "Déplacement de l’implant ou bord visible le long de l’os, ou asymétrie et projection jugée excessive ou insuffisante, nécessitant une reprise",
        "Résorption osseuse sous un implant ancien, qui peut rendre sa tenue moins bonne au fil des années",
        "Pour la génioplastie : saignement, lésion des racines dentaires et problèmes liés aux plaques de fixation"
      ],
      "note": "Parlez-nous d’une chirurgie antérieure du menton ou de la mâchoire, d’un traitement orthodontique, d’une maladie des gencives et de toute maladie auto-immune. Dites-nous aussi si vous serrez les dents ou souffrez d’une douleur de l’ATM — l’articulation est sollicitée différemment après un déplacement du menton."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Verra-t-on que je l’ai fait ?",
          "a": "L’objectif est la proportion, pas la taille. Un implant choisi pour votre visage se lit comme une mâchoire plus marquée plutôt que comme un menton. L’incision est dans la lèvre, donc pas de cicatrice sur le visage ; la contrepartie est une courte période d’œdème et une lèvre inférieure insensible."
        },
        {
          "q": "Implant ou génioplastie — que choisir ?",
          "a": "L’implant est plus rapide, réversible et adapté pour ajouter de la projection vers l’avant. La génioplastie déplace votre propre os : elle peut allonger le menton, corriger une asymétrie et éviter un corps étranger, au prix d’une opération plus lourde. La bonne réponse dépend de ce qui est réellement court, et cela se mesure, ne se devine pas."
        },
        {
          "q": "Combien de temps dure un implant ?",
          "a": "Un implant en silicone n’est pas censé devoir être remplacé, et beaucoup restent en place des décennies. Il n’est pas définitif au sens où il ne demanderait jamais d’attention : il peut être retiré ou remplacé, et doit être examiné s’il devient douloureux, s’il se déplace ou si le menton change de forme."
        },
        {
          "q": "Peut-on l’associer à une opération du nez ?",
          "a": "Oui, et c’est souvent le meilleur plan : le profil est une relation entre le nez et le menton, et modifier l’un seul peut faire paraître l’autre inadapté. L’intervention combinée est plus longue, elle est donc planifiée comme une seule procédure avec une seule récupération."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Un profil et une vue de face suffisent pour dire si le menton est le problème, et si un implant, l’os ou un filler est la voie raisonnable. Un coordinateur revient vers vous avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Augmentation du menton à Istanbul | Clinique Platinya",
    "seoDesc": "Augmentation du menton à Istanbul : implant, glissement osseux ou filler, choisis selon la projection nécessaire. L’œdème se résorbe en une à deux semaines."
  },
  "/blepharoplasty": {
    "title": "Blépharoplastie (chirurgie des paupières) à Istanbul",
    "eyebrow": "Chirurgie plastique du visage",
    "lead": "La blépharoplastie retire l’excès de peau des paupières supérieures et la graisse qui donne aux paupières inférieures un aspect fatigué et gonflé. C’est l’une des plus petites opérations du visage, et l’une des plus faciles à rater.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de chirurgie des paupières à la clinique Platinya",
    "stats": [
      {
        "value": "1–2 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "5–7 jours",
        "label": "Retrait des fils"
      },
      {
        "value": "7–10 jours",
        "label": "Retour en public"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "L’intervention traite la peau et la graisse, pas la couleur ni la qualité de la peau. Les cernes d’origine pigmentaire, ou le creux sous l’œil, sont un problème différent qui appelle une autre réponse.",
      "items": [
        "Paupières supérieures tombantes, ou peau qui repose sur les cils et rétrécit le champ visuel",
        "Peau de la paupière supérieure plissée, lourde ou asymétrique",
        "Paupières inférieures gonflées par une graisse qui a avancé, et non par de la rétention d’eau",
        "Peau relâchée de la paupière inférieure, avec ou sans poche graisseuse visible"
      ],
      "note": "La sécheresse oculaire, l’orbitopathie thyroïdienne, le glaucome et l’hypertension artérielle modifient tous le plan, et certains sont une raison d’attendre. Une maladie thyroïdienne doit être stabilisée avant l’intervention : opérer une orbitopathie thyroïdienne active peut l’aggraver."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Les paupières supérieures et inférieures sont deux décisions distinctes. Beaucoup de patients n’ont besoin que de l’une des deux, et en faire plus que nécessaire est la manière dont les paupières finissent par paraître creuses.",
      "items": [
        {
          "name": "Blépharoplastie supérieure",
          "text": "Une incision fine dans le pli naturel, l’excès de peau retiré avec une bande de muscle ; la graisse n’est retirée que là où elle bombe. La cicatrice se situe dans le pli et s’estompe en trois à six mois. C’est la partie qui élargit le champ visuel."
        },
        {
          "name": "Paupière inférieure, voie transconjonctivale",
          "text": "La graisse est retirée par l’intérieur de la paupière, sans incision cutanée ni cicatrice externe. Adaptée aux poches graisseuses avec un bon tonus cutané ; elle ne retire pas la peau relâchée. Souvent associée à un repositionnement de la graisse pour combler le sillon lacrymal."
        },
        {
          "name": "Paupière inférieure, voie externe avec canthopexie",
          "text": "Une incision juste sous les cils retire la peau ainsi que la graisse, et le coin de la paupière est soutenu pour qu’il ne tombe pas. Utilisée en cas d’excès cutané réel — et technique où le risque de paupière tirée vers le bas doit être géré avec prudence."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Les paupières sont examinées yeux ouverts et yeux fermés, la quantité de peau à conserver est mesurée et la sécheresse oculaire est évaluée. Des photographies sont prises. En cas de doute sur le film lacrymal ou la thyroïde, un avis ophtalmologique est organisé avant de fixer une date."
        },
        {
          "name": "Préparation",
          "text": "Les anticoagulants, l’aspirine et certains compléments sont suspendus environ dix jours avant, et le tabac est arrêté quatre semaines avant. Vous restez à jeun six à huit heures. Organisez-vous pour que quelqu’un vous ramène : les yeux sont gonflés et conduire est impossible."
        },
        {
          "name": "L’intervention",
          "text": "Anesthésie locale avec sédation légère, ou anesthésie générale, une à deux heures pour les deux paupières. En anesthésie locale, vous êtes éveillé et pouvez parler au chirurgien. Les fils sont fins et retirés après cinq à sept jours ; certains sont résorbables."
        },
        {
          "name": "La première semaine",
          "text": "Des hématomes et un œdème sont attendus, et peuvent être importants les trois ou quatre premiers jours. Compresses froides, tête surélevée et collyres. La vision est floue à cause de la pommade plutôt que de l’intervention. Pas de lentilles de contact pendant environ deux semaines."
        },
        {
          "name": "Semaines deux à douze",
          "text": "La plupart des personnes peuvent se montrer après sept à dix jours, avec du maquillage à partir du dixième jour environ. L’œdème résiduel diminue en quatre à six semaines et la cicatrice s’assouplit en trois à six mois. La protection solaire des paupières est importante pendant cette période."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "La chirurgie des paupières a une liste courte de risques, et l’un d’eux est une urgence. Tous méritent d’être lus avant l’intervention.",
      "items": [
        "Ectropion ou rétraction de la paupière inférieure — la paupière tire vers le bas, l’œil ne se ferme plus complètement et devient sec et irrité ; une reprise peut être nécessaire",
        "Asymétrie entre les deux côtés, ou retrait d’une trop grande quantité de peau, difficile à corriger",
        "Un hématome derrière l’œil — rare, mais menaçant pour la vue, et une raison de revenir immédiatement",
        "Vision double, par atteinte des muscles qui mobilisent l’œil ; généralement temporaire, rarement définitive",
        "Cicatrices visibles ou épaissies, et petits kystes le long de la ligne d’incision"
      ],
      "note": "Parlez-nous de la sécheresse oculaire, du port de lentilles, d’une maladie thyroïdienne, du glaucome, de troubles de la coagulation et de tout anticoagulant, y compris l’aspirine et l’huile de poisson. Dites-nous aussi si vous avez eu des injections de filler ou du laser autour des yeux — cela change le comportement des tissus."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Cela va-t-il changer la forme de mes yeux ?",
          "a": "La forme est définie par les paupières et le sourcil, et l’intervention est planifiée autour d’eux. Retirer de la peau ouvre l’œil ; cela ne doit pas le rendre plus rond ni donner un air effrayé. Si le sourcil est bas, le relever plutôt que retirer davantage de peau est souvent la bonne réponse."
        },
        {
          "q": "Cela peut-il retirer les cernes ?",
          "a": "En partie, et seulement si l’obscurité est une ombre créée par une poche graisseuse ou par un creux. Les cernes d’origine pigmentaire ne changent pas avec la chirurgie et se traitent par des crèmes, des peelings ou du laser. C’est le malentendu le plus fréquent au sujet de cette intervention."
        },
        {
          "q": "Combien de temps le résultat dure-t-il ?",
          "a": "Généralement cinq à dix ans, parfois plus pour les paupières supérieures. La peau continue de vieillir et le sourcil continue de descendre : le résultat est une amélioration plutôt qu’un état définitif. Une seconde intervention, plus limitée, est parfois réalisée des années plus tard."
        },
        {
          "q": "Supérieure ou inférieure — de quoi ai-je besoin ?",
          "a": "Cela se décide à l’examen. Un repli cutané et un champ visuel réduit orientent vers la paupière supérieure ; un gonflement et une ombre sous l’œil orientent vers l’inférieure. Beaucoup de patients ne se voient proposer qu’une seule des deux, et les associer est une décision qui concerne autant le temps de récupération que le résultat."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Une vue de face yeux ouverts et une autre yeux doucement fermés suffisent à un chirurgien pour juger quelle paupière doit être opérée et quelle quantité de peau peut être conservée en sécurité. Un coordinateur répond avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Blépharoplastie (paupières) à Istanbul | Clinique Platinya",
    "seoDesc": "Chirurgie des paupières supérieures et inférieures à Istanbul : excès de peau et poches retirés, fils retirés en cinq à sept jours. Risques exposés clairement."
  },
  "/silicone": {
    "title": "Augmentation mammaire par implants en silicone à Istanbul",
    "eyebrow": "Remodelage corporel",
    "lead": "L’augmentation mammaire ajoute du volume et améliore la symétrie grâce à un implant placé derrière le tissu mammaire ou derrière le muscle. Elle modifie la taille et la forme ; elle ne remonte pas un sein déjà ptosé.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation d’augmentation mammaire à la clinique Platinya",
    "stats": [
      {
        "value": "1–2 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1 nuit",
        "label": "Hospitalisation"
      },
      {
        "value": "4–6 semaines",
        "label": "Sans sport"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Le point de départ est le tissu dont vous disposez — son épaisseur, son élasticité et la position du mamelon — et non le bonnet que vous souhaitez. L’implant est choisi pour s’adapter à la poitrine.",
      "items": [
        "Des seins naturellement petits, ou d’une taille qui n’a jamais correspondu au reste de la silhouette",
        "Une asymétrie marquée entre les deux côtés",
        "Un volume perdu après l’allaitement ou une perte de poids, avec une peau encore ferme",
        "Un sein vide dans le pôle supérieur, où un implant modéré restaure le galbe"
      ],
      "note": "Si le mamelon se situe sous le sillon sous-mammaire, le problème est une ptose, et un implant seul ne la corrigera pas — il peut même l’aggraver. Cela nécessite un lifting, avec ou sans implant. Une mammographie ou une échographie est organisée avant l’intervention selon votre âge et vos antécédents familiaux, et toute masse est explorée d’abord."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Trois décisions se prennent ensemble : ce que l’on met, où on le met et comment on l’introduit. Chacune modifie l’aspect, la récupération et le risque.",
      "items": [
        {
          "name": "L’implant : rond ou anatomique",
          "text": "Les implants modernes sont remplis d’un gel de silicone cohésif qui garde sa forme. Les implants ronds donnent du galbe au pôle supérieur ; les anatomiques (en goutte d’eau) sont profilés pour suivre la pente naturelle et sont généralement texturés pour les empêcher de tourner. La surface et la forme se choisissent avec le chirurgien, et les deux ont des compromis."
        },
        {
          "name": "Le plan : sous le muscle ou dual-plane",
          "text": "Le placement derrière le muscle pectoral masque le bord de l’implant et convient aux tissus fins ; le dual-plane libère la partie inférieure du muscle pour que l’implant se place naturellement tandis que la partie supérieure le recouvre encore. Au-dessus du muscle, la récupération est plus rapide mais l’implant se voit davantage chez les patients minces."
        },
        {
          "name": "L’incision",
          "text": "Sous le sein, dans le sillon, est la plus courante et offre le contrôle le plus direct. Autour de l’aréole, elle cache la cicatrice dans le changement de pigmentation mais comporte un risque un peu plus élevé de modification de la sensibilité du mamelon ; par l’aisselle, il n’y a pas de cicatrice sur le sein mais la précision est moindre."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Des mesures de la poitrine, de la qualité de peau et de la position du mamelon, et une conversation sur la taille souhaitée — essayée avec des prothèses d’essai, pas choisie sur une photo. Mammographie ou échographie si indiquée, analyses de sang, et un plan écrit nommant l’implant."
        },
        {
          "name": "Préparation",
          "text": "Le tabac est arrêté quatre semaines avant, les anticoagulants et certains compléments environ dix jours avant, et vous restez à jeun six à huit heures. Achetez le soutien-gorge chirurgical à l’avance et organisez de l’aide les trois ou quatre premiers jours : porter des charges et conduire sont impossibles."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale, une à deux heures. L’implant est mis en place, la position est vérifiée avec vous en position assise pendant l’opération, et l’incision est fermée plan par plan. La plupart des patients restent une nuit, avec un soutien-gorge de compression ajusté avant la sortie."
        },
        {
          "name": "Les deux premières semaines",
          "text": "La tension et l’œdème sont plus marqués les trois à cinq premiers jours, et les seins sont hauts. Le soutien-gorge de compression se porte jour et nuit, les drains sont rares, et la première douche est programmée à la clinique. Dormir sur le dos, surélevé, est plus confortable."
        },
        {
          "name": "Semaines trois à six",
          "text": "L’œdème diminue et les implants descendent en position sur six à douze semaines. Le travail de bureau est généralement possible après une à deux semaines. La salle de sport, la course, la natation et le port de charges attendent quatre à six semaines ; le travail du haut du corps est réintroduit progressivement ensuite."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Un implant est un dispositif, avec une durée de vie et un taux d’échec. Voici les risques qui comptent, y compris les plus rares.",
      "items": [
        "Contracture capsulaire — le tissu cicatriciel autour de l’implant se rétracte, rendant le sein dur, rond et parfois douloureux ; elle peut être traitée mais récidive parfois",
        "LAGC-AIM (lymphome anaplasique à grandes cellules associé aux implants mammaires), un lymphome rare de la capsule, lié principalement aux implants texturés et apparaissant des années plus tard sous forme d’un gonflement ou d’un épanchement ; il se traite par l’ablation de l’implant et de la capsule",
        "Rupture ou fuite, qui peut être totalement asymptomatique et se découvrir à l’imagerie, ainsi que des vagues ou des bords visibles à travers une peau fine",
        "Infection, pouvant imposer le retrait de l’implant et son remplacement plus tard, et modification de la sensibilité du mamelon ou du sein — souvent temporaire, parfois définitive",
        "Saignement, hématome et, rarement, thrombose — réduits par la marche précoce et la compression"
      ],
      "note": "Parlez-nous de toute chirurgie mammaire antérieure, d’antécédents familiaux de cancer du sein ou de l’ovaire, de maladie auto-immune et de tabac. Les implants n’empêchent pas le dépistage du cancer du sein, mais ils modifient la réalisation de la mammographie — signalez-le lorsque vous prenez rendez-vous."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de temps durent les implants ?",
          "a": "Ce ne sont pas des dispositifs à vie. Beaucoup durent dix à quinze ans ou plus, mais une rupture, une contracture ou un changement de forme peut avancer le remplacement. Il n’y a pas de calendrier fixe : l’implant est surveillé — par examen et, si besoin, échographie ou IRM — et remplacé s’il y a une raison."
        },
        {
          "q": "Pourrai-je allaiter ?",
          "a": "La plupart des femmes le peuvent, en particulier avec une incision dans le sillon et un placement dual-plane, qui laissent largement intacts les canaux lactifères et l’innervation. Certaines femmes produisent moins, et une incision aréolaire comporte un risque plus élevé de modification de la sensibilité du mamelon. Il vaut la peine de planifier l’opération en pensant à une grossesse future."
        },
        {
          "q": "Les implants causent-ils un cancer du sein ?",
          "a": "Il n’a pas été démontré que les implants en silicone causent un cancer du sein. Le LAGC-AIM est un lymphome rare et distinct de la capsule cicatricielle autour de l’implant, et non un cancer du sein ; c’est pourquoi tout gonflement, masse ou douleur nouveaux autour d’un implant sont explorés plutôt que surveillés. Le risque est faible, mais il est réel et vous devez le connaître."
        },
        {
          "q": "Ai-je plutôt besoin d’un lifting ?",
          "a": "Si le mamelon se situe au niveau du sillon ou en dessous, oui — ou un lifting avec un implant plus petit. Un implant ajoute du volume vers l’avant, pas vers le haut, et sur un sein ptosé il peut produire une forme plus lourde et plus basse. Cela s’examine debout, et c’est la raison la plus fréquente de modification du plan en consultation."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Des vues de face et de profil, en haut ajusté, suffisent pour discuter si un implant seul suffira, quel volume correspond à votre silhouette et ce que l’opération implique. Un coordinateur répond avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Augmentation mammaire à Istanbul | Clinique Platinya",
    "seoDesc": "Augmentation mammaire à Istanbul : implants en silicone cohésif, ronds ou anatomiques, une nuit d’hospitalisation. Contracture capsulaire et LAGC-AIM expliqués."
  },
  "/butt-augmentation-surgery": {
    "title": "Augmentation des fesses (BBL) à Istanbul",
    "eyebrow": "Remodelage corporel",
    "lead": "L’augmentation des fesses modifie la forme et la projection des fessiers, soit en transférant de la graisse prélevée ailleurs sur votre corps, soit en posant un implant. C’est l’une des interventions les plus exigeantes du remodelage corporel — pour le chirurgien comme pour la récupération.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation d’augmentation des fesses à la clinique Platinya",
    "stats": [
      {
        "value": "3–5 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "1–2 nuits",
        "label": "Hospitalisation"
      },
      {
        "value": "2–3 semaines",
        "label": "Position assise prudente"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Un transfert de graisse nécessite de la graisse à transférer et une peau capable d’accueillir ce nouveau volume. Les deux s’évaluent debout, et les deux déterminent si l’intervention est seulement possible.",
      "items": [
        "Assez de graisse sur l’abdomen, les flancs, le dos ou les cuisses à prélever, avec un poids stable",
        "Des fessiers plats, carrés ou manquant de projection de profil",
        "Une asymétrie, ou une perte de forme après une perte de poids",
        "Un bon tonus cutané, et aucun antécédent de thrombose ni de problème après une liposuccion"
      ],
      "note": "Ce n’est pas une opération de perte de poids et cela ne remplace pas l’entraînement. Si vous êtes en insuffisance pondérale, il n’y aura peut-être rien à prélever, et l’implant est alors la seule option — avec un autre ensemble de risques. Le tabac, les troubles de la coagulation et un diabète non équilibré sont des raisons de reconsidérer la décision."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Deux opérations portent le même nom. Elles ne sont pas des variantes l’une de l’autre : elles diffèrent par le matériau, la récupération et les risques graves.",
      "items": [
        {
          "name": "Transfert de graisse (Brazilian butt lift)",
          "text": "La graisse est aspirée sur l’abdomen, les flancs ou le dos, lavée et laissée au repos, puis injectée dans les fessiers par petits passages. C’est votre propre tissu : le toucher est naturel et les zones donneuses sont remodélées en même temps. La totalité de la graisse ne survit pas."
        },
        {
          "name": "Implants fessiers",
          "text": "Un implant en silicone solide est placé par une incision dans le pli interfessier, en profondeur du fascia ou dans le muscle. Il donne un volume prévisible qui ne diminue pas, mais c’est un corps étranger avec un risque de déplacement, d’infection et de formation d’une coque, et la cicatrice se situe dans une zone sensible."
        },
        {
          "name": "Association et reprise",
          "text": "Le transfert de graisse peut être associé à un petit implant, ou répété après six à douze mois pour ajouter du volume une fois le premier transfert stabilisé. La reprise d’un BBL antérieur est généralement plus difficile que la première intervention, car le tissu cicatriciel modifie les plans de dissection."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Des photographies debout, une évaluation de la graisse disponible et de l’élasticité cutanée, et un historique médical incluant la coagulation, les saignements et les interventions antérieures. Des analyses de sang et, si nécessaire, un avis cardiologique ou anesthésique, avant de fixer une date."
        },
        {
          "name": "Préparation",
          "text": "Le tabac est arrêté au moins quatre semaines avant ; la nicotine nuit à la survie de la graisse et à la cicatrisation. Les anticoagulants, la pilule contraceptive et certains compléments sont discutés et suspendus lorsque c’est approprié. Achetez des vêtements amples et un coussin BBL, et organisez de l’aide à la maison — vous ne pourrez pas vous allonger ni vous asseoir normalement pendant des semaines."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale, trois à cinq heures. La graisse est prélevée, traitée et injectée par petites quantités, en restant à distance des vaisseaux profonds. Un vêtement de compression est mis en place, et la plupart des patients restent une ou deux nuits."
        },
        {
          "name": "Les deux premières semaines",
          "text": "Vous dormez sur le ventre ou sur le côté, et vous ne vous asseyez que sur le coussin prévu, brièvement. Les zones donneuses sont contuses et douloureuses, et les vêtements de compression sont portés en continu. La marche est encouragée dès le premier jour ; les fessiers sont gonflés et la forme n’est pas encore définitive."
        },
        {
          "name": "Semaines trois à douze",
          "text": "La position assise devient confortable en deux à trois semaines, la conduite après deux à trois semaines et le sport après six à huit. L’œdème diminue en trois mois ; la graisse qui survit est définitive, mais la forme finale s’apprécie à trois à six mois."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Cette intervention comporte un risque grave qui lui est propre, et il doit être énoncé clairement plutôt que mentionné en passant.",
      "items": [
        "Embolie graisseuse — de la graisse pénètre dans la circulation sanguine et atteint les poumons ; elle peut être mortelle, et aucune technique n’élimine totalement ce risque",
        "Nécrose graisseuse, kystes huileux et indurations dans les zones transférées, nécessitant parfois un drainage",
        "Infection, qui dans un plan fessier profond peut être difficile à traiter et imposer le retrait de l’implant ; sérome ou retard de cicatrisation sur les zones donneuses",
        "Asymétrie, irrégularité du contour ou un résultat plus petit que prévu, car une part variable de la graisse ne survit pas",
        "Thrombose ou embolie pulmonaire, réduites par la marche précoce et la compression — et, avec les implants, déplacement, coque et cicatrices épaissies"
      ],
      "note": "Demandez directement à toute clinique comment elle évite l’injection intravasculaire profonde, qui réalise l’anesthésie et ce qui se passe en cas de complication. Une clinique qui répond vaguement sur l’embolie graisseuse n’est pas une clinique avec laquelle réserver."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Quelle part de la graisse survit ?",
          "a": "Une proportion variable — une part souvent importante est réabsorbée, et le résultat est plus petit que le volume postopératoire immédiat. C’est pourquoi l’intervention est planifiée de façon prudente et pourquoi une seconde séance est parfois nécessaire après six à douze mois. Aucun chirurgien ne peut promettre un pourcentage."
        },
        {
          "q": "Combien de temps avant de pouvoir m’asseoir normalement ?",
          "a": "Deux à trois semaines à ne s’asseoir que sur un coussin, pour de courtes durées, et à dormir sur le ventre ou sur le côté. Une pression prolongée dans les premières semaines est censée réduire la survie de la graisse. La conduite attend deux à trois semaines ; les vols longs, quatre à six."
        },
        {
          "q": "Un BBL est-il dangereux ?",
          "a": "Il comporte un risque réel d’embolie graisseuse, potentiellement mortelle, et ce risque est plus élevé que dans la plupart des opérations esthétiques. Il est réduit par une technique soignée — canules fines, évitement du muscle profond et des gros vaisseaux, limitation du volume — mais pas supprimé. Il est légitime de conclure que le risque n’en vaut pas la peine."
        },
        {
          "q": "Graisse ou implant — que choisir ?",
          "a": "La graisse donne un toucher naturel et remodèle les zones donneuses, mais une partie du volume est perdue et la limite est la quantité de graisse dont vous disposez. L’implant donne un volume prévisible sans second site opératoire, au prix d’un corps étranger et d’un risque plus élevé d’infection et de déplacement. C’est généralement votre répartition de tissu graisseux qui tranche."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Des vues de profil et de dos, en vêtements ajustés, permettent à un chirurgien de juger la projection et la graisse disponible — et de dire honnêtement si un transfert est possible. Un coordinateur répond avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "BBL et augmentation des fessiers à Istanbul | Platinya",
    "seoDesc": "Augmentation des fessiers à Istanbul : transfert de graisse ou implant, chiffres honnêtes sur la survie de la graisse et les risques rares."
  },
  "/liposuction": {
    "title": "Liposuccion à Istanbul (VASER et tumescente)",
    "eyebrow": "Remodelage corporel",
    "lead": "La liposuccion retire la graisse de zones précises pour modifier les contours du corps. C’est une opération de remodelage : la balance bouge à peine, et ce qui change est la répartition de la graisse.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de liposuccion à la clinique Platinya",
    "stats": [
      {
        "value": "1–3 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "Ambulatoire",
        "label": "ou une nuit"
      },
      {
        "value": "4–6 semaines",
        "label": "Vêtement de compression"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Deux éléments décident du résultat : la quantité de graisse à retirer et la capacité de la peau à se rétracter ensuite. C’est le second que les patients sous-estiment.",
      "items": [
        "Une graisse localisée sur l’abdomen, les flancs, le dos, les cuisses ou les bras, qui n’a pas changé avec l’entraînement",
        "Un poids stable depuis environ six mois, proche de celui que vous comptez conserver",
        "Une peau qui a encore de l’élasticité — elle doit se rétracter sur le nouveau contour",
        "Aucun trouble de la coagulation, et pas de diabète ni de maladie cardiaque non équilibrés"
      ],
      "note": "La liposuccion n’est pas un traitement de l’obésité et ne remplace pas une perte de poids. S’il reste beaucoup de poids à perdre, le perdre d’abord donne un résultat meilleur et plus sûr. Si la peau est déjà relâchée, retirer la graisse située dessous rend le relâchement plus visible — cela relève d’un retrait de peau, pas d’une liposuccion supplémentaire."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "Toute liposuccion passe par de petites incisions avec une canule. La différence tient à la façon dont la graisse est détendue avant d’être aspirée, et à la surface traitée en une séance.",
      "items": [
        {
          "name": "Liposuccion tumescente",
          "text": "Un grand volume d’anesthésique local dilué et d’adrénaline est injecté d’abord, ce qui insensibilise la zone, contracte les vaisseaux et réduit le saignement. La graisse est ensuite aspirée par une canule. C’est la technique standard, et celle sur laquelle la plupart des autres reposent."
        },
        {
          "name": "VASER (assistée par ultrasons)",
          "text": "L’énergie ultrasonore détend la graisse avant son retrait. Elle est présentée comme plus douce pour les tissus environnants et comme favorisant la rétraction cutanée, en particulier sur le dos et les flancs. Elle est plus lente, plus coûteuse et comporte son propre risque de brûlures sous la peau."
        },
        {
          "name": "Remodelage 360°",
          "text": "L’abdomen, les flancs et le dos sont traités comme une seule unité continue, afin que la transition autour de la taille soit régulière plutôt qu’une série de zones séparées. Intervention plus longue et volume retiré plus important : elle se planifie donc avec plus de soin et un temps de récupération plus long."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et planification",
          "text": "Les zones sont marquées debout, l’élasticité cutanée est évaluée, et le volume attendu est discuté honnêtement — y compris ce qui ne changera pas. Des analyses de sang et, si nécessaire, un avis cardiologique, avant de fixer une date."
        },
        {
          "name": "Préparation",
          "text": "Le tabac est arrêté quatre semaines avant, les anticoagulants et certains compléments environ dix jours avant, et vous restez à jeun six à huit heures. Les vêtements de compression sont mesurés et commandés à l’avance. Organisez de l’aide à la maison les deux ou trois premiers jours."
        },
        {
          "name": "L’intervention",
          "text": "Sous sédation ou anesthésie générale, une à trois heures selon le nombre de zones. Un liquide est infiltré, la graisse est aspirée par des incisions de quelques millimètres et le vêtement est mis au bloc. La plupart des patients rentrent le jour même ; les volumes plus importants restent une nuit."
        },
        {
          "name": "Les deux premières semaines",
          "text": "Du liquide suinte des incisions pendant un jour ou deux, et le vêtement se porte jour et nuit. Les hématomes sont étendus et atteignent leur maximum la première semaine. Marche dès le premier jour ; le travail de bureau est généralement possible après trois à sept jours."
        },
        {
          "name": "Semaines trois à douze",
          "text": "L’œdème diminue sur quatre à six semaines, et le vêtement se poursuit pendant cette période. Le sport reprend à quatre à six semaines. Le contour s’affine sur trois à six mois, et le résultat final s’apprécie à six à douze mois."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "La liposuccion est courante et reste une chirurgie, avec un petit nombre de risques qui sont graves plutôt qu’esthétiques.",
      "items": [
        "Irrégularité du contour, capitons ou asymétrie — la plainte la plus fréquente, et la plus difficile à corriger",
        "Relâchement ou affaissement cutané après le retrait de graisse, lorsque l’élasticité était déjà mauvaise",
        "Brûlures ou nécrose cutanée, en particulier avec les techniques assistées par ultrasons",
        "Infection, sérome nécessitant des drainages répétés et retard de cicatrisation aux incisions",
        "Thrombose, embolie pulmonaire et embolie graisseuse — rares, réduites par la marche précoce et la compression ; une lésion interne de la paroi abdominale ou des organes est encore plus rare et plus probable avec une aspiration profonde agressive"
      ],
      "note": "Parlez-nous des anticoagulants, des troubles de la coagulation, d’une maladie cardiaque ou hépatique et de toute liposuccion antérieure dans la même zone. Il existe une limite à ce qui peut être retiré sans risque en une séance ; un chirurgien qui accepte n’importe quel volume demandé n’est pas prudent."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de poids vais-je perdre ?",
          "a": "Très peu, et c’est délibéré : la graisse est plus légère qu’elle n’en a l’air, et le volume sûr en une séance est limité. Le changement porte sur la silhouette et sur la façon dont les vêtements tombent. Si l’objectif est une perte de poids, ce n’est pas la bonne opération."
        },
        {
          "q": "La graisse reviendra-t-elle ?",
          "a": "Les cellules graisseuses retirées ne reviennent pas, mais celles qui restent peuvent grossir si vous prenez du poids — et elles ont tendance à grossir uniformément, ce qui peut modifier la forme. C’est la stabilité du poids qui protège le résultat."
        },
        {
          "q": "Cela traite-t-il la cellulite ?",
          "a": "Pas de façon fiable. La cellulite est une structure de la peau et des bandes fibreuses sous-jacentes, pas simplement de la graisse. La liposuccion peut parfois rendre les capitons plus visibles, car elle retire la graisse qui les comblait. Soyez sceptique devant quiconque la vend comme une cure de cellulite."
        },
        {
          "q": "Quand verrai-je le résultat ?",
          "a": "Un changement précoce est visible à deux ou trois semaines, mais l’œdème masque le vrai contour plus longtemps. L’essentiel du résultat est là à trois mois, et la forme finale à six à douze mois — moment où une reprise, si nécessaire, serait envisagée."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Des vues de face, de côté et de dos suffisent pour dire quelles zones peuvent être traitées, quel volume est réaliste et si la peau se rétractera. Un coordinateur répond avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Liposuccion (VASER) à Istanbul | Clinique Platinya",
    "seoDesc": "Liposuccion à Istanbul : techniques VASER et tumescente, compression pendant quatre à six semaines. Pourquoi c’est un remodelage et non une perte de poids."
  },
  "/gynecomastia": {
    "title": "Gynécomastie (réduction mammaire masculine) à Istanbul",
    "eyebrow": "Remodelage corporel",
    "lead": "La gynécomastie est une augmentation du sein masculin. La chirurgie retire la glande située derrière le mamelon, la graisse qui l’entoure, ou les deux — mais seulement après avoir recherché la cause, car certaines causes sont médicales et certaines sont réversibles.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de gynécomastie à la clinique Platinya",
    "stats": [
      {
        "value": "1–2 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "Ambulatoire",
        "label": "ou une nuit"
      },
      {
        "value": "3–4 semaines",
        "label": "Gilet de compression"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "La vraie gynécomastie est du tissu glandulaire — un disque ferme derrière le mamelon — et elle ne disparaît pas avec l’entraînement. La graisse seule constitue une pseudogynécomastie, qui se traite différemment.",
      "items": [
        "Un disque de tissu ferme, parfois sensible, derrière un ou les deux mamelons",
        "Une augmentation stable depuis deux ans ou plus après la puberté",
        "Une pseudogynécomastie : de la graisse sans glande, chez une personne proche de son poids stable",
        "Une gêne, une asymétrie, ou une restriction dans ce que vous portez ou faites"
      ],
      "note": "Avant toute intervention, la cause est écartée. Les médicaments — cannabis, stéroïdes anabolisants, alcool, certains antihypertenseurs et traitements de la prostate — en sont la cause réversible la plus fréquente. Les troubles hormonaux, les maladies thyroïdiennes, hépatiques ou rénales et, rarement, une tumeur testiculaire se présentent aussi ainsi. Les analyses de sang et un examen testiculaire viennent d’abord ; si quelque chose est trouvé, cela se traite, on n’opère pas autour."
    },
    "techniques": {
      "heading": "Ce qui peut être fait, et comment on le choisit",
      "intro": "L’intervention est planifiée selon ce qui est réellement présent — glande, graisse ou peau — et ces trois composantes existent en proportions différentes selon les hommes.",
      "items": [
        {
          "name": "Exérèse de la glande",
          "text": "La glande est retirée par une incision semi-circulaire autour de la moitié inférieure de l’aréole. C’est le seul moyen de retirer un tissu glandulaire ferme, et l’incision cicatrise généralement bien car elle suit le bord de la pigmentation. Un petit drain est souvent laissé un jour ou deux."
        },
        {
          "name": "Liposuccion",
          "text": "Utilisée pour la composante graisseuse et pour estomper les bords afin que le torse ne paraisse pas opéré. Seule, elle ne retire pas la glande : c’est pourquoi une liposuccion isolée laisse souvent une boule dure derrière le mamelon — la raison la plus fréquente d’une reprise."
        },
        {
          "name": "Associée à un retrait de peau",
          "text": "En cas d’augmentation importante, ou après une perte de poids majeure, il existe un excès de peau qui ne se rétractera pas. Il est retiré, avec une cicatrice placée autour de l’aréole ou horizontalement sur le torse. Une opération plus lourde, et une cicatrice qu’il faut accepter."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation à la récupération",
      "steps": [
        {
          "name": "Consultation et évaluation",
          "text": "Le torse est examiné allongé et debout, la glande est distinguée de la graisse et les testicules sont examinés. Des analyses hormonales et hépatiques, et une échographie du torse ou des testicules si indiquée, avant toute programmation."
        },
        {
          "name": "Préparation",
          "text": "Tout médicament en cause est arrêté avec l’accord du médecin qui le prescrit — jamais de votre propre initiative s’il est prescrit. Le tabac est arrêté quatre semaines avant, les anticoagulants environ dix jours avant, et vous restez à jeun six à huit heures. Un gilet de compression est commandé à l’avance."
        },
        {
          "name": "L’intervention",
          "text": "Sous anesthésie générale, une à deux heures. La glande est excisée, la graisse lipoaspirée, et le contour est vérifié avec vous en position assise. Le gilet est mis au bloc. La plupart des patients rentrent le jour même, certains restent une nuit."
        },
        {
          "name": "Les deux premières semaines",
          "text": "Le gilet se porte jour et nuit, et un drain — s’il a été utilisé — est retiré en un jour ou deux. L’œdème et les hématomes sont importants, et le torse est tendu. Travail de bureau après trois à sept jours ; pas de port de charges, pas d’exercices de pectoraux."
        },
        {
          "name": "Semaines trois à douze",
          "text": "Le gilet est poursuivi trois à quatre semaines au total. Exercice aérobie à trois ou quatre semaines, charges et travail des pectoraux à six. L’œdème diminue en trois mois, et le contour final — y compris une éventuelle petite irrégularité — s’apprécie à six mois."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "La plupart des risques ici concernent le contour, et l’un concerne une cause laissée sans traitement.",
      "items": [
        "Déformation du contour — un creux en soucoupe, une boule résiduelle ou une asymétrie entre les deux côtés, si trop ou pas assez de tissu est retiré",
        "Récidive, si du tissu glandulaire est laissé en place ou si un médicament en cause est poursuivi",
        "Insensibilité ou hypersensibilité du mamelon, s’améliorant généralement en quelques mois",
        "Cicatrices de mauvaise qualité ou élargies et, rarement, perte du complexe aréolo-mamelonnaire si sa vascularisation est compromise",
        "Thrombose, réduite par la marche précoce, et infection — plus probable chez les fumeurs ; hématome ou sérome pouvant nécessiter un drainage et affecter la forme finale"
      ],
      "note": "Dites honnêtement ce que vous prenez — stéroïdes, cannabis, compléments, médicaments prescrits. Ce n’est pas un jugement : c’est la différence entre une opération qui fonctionne et une qui revient. Si une cause hormonale est trouvée, elle est traitée séparément."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Est-ce un cancer ?",
          "a": "La gynécomastie elle-même n’est pas un cancer du sein et, chez l’homme, elle est généralement bénigne. Mais une masse unilatérale, dure, fixée ou avec écoulement n’est pas la même chose et doit être explorée — c’est pourquoi l’examen et, si besoin, l’échographie précèdent la chirurgie plutôt que de la suivre."
        },
        {
          "q": "Cela reviendra-t-il ?",
          "a": "Si la glande est correctement excisée et la cause supprimée, la récidive est rare. Elle survient plus souvent lorsque seule une liposuccion a été réalisée, lorsqu’une part de glande a été laissée pour préserver le mamelon, ou lorsque stéroïdes ou cannabis sont poursuivis. Un léger comblement résiduel n’est pas une récidive."
        },
        {
          "q": "Dois-je arrêter le cannabis ou les stéroïdes ?",
          "a": "Oui — et pas seulement pour la cicatrisation. Les deux peuvent entretenir l’augmentation, et les poursuivre après l’intervention est le moyen le plus sûr de l’annuler. Les médicaments prescrits sont différents : ils ne sont modifiés qu’avec le médecin qui les a prescrits."
        },
        {
          "q": "Y aura-t-il une cicatrice visible ?",
          "a": "L’incision suit le bord inférieur de l’aréole et s’estompe généralement en une fine ligne en six à douze mois. Si de la peau doit être retirée, la cicatrice est plus longue — autour de l’aréole ou en travers du torse. Elle est définitive, et c’est le principal compromis de l’intervention."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez vos photos pour un premier avis",
      "text": "Une vue de face et une vue de côté suffisent pour juger s’il s’agit de glande, de graisse ou de peau — et si des analyses de sang sont nécessaires avant tout le reste. Un coordinateur répond avec un plan et un devis écrit.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Cette page est une information générale, pas un avis médical. La faisabilité, la technique et les risques sont décidés lors d’une consultation avec un chirurgien.",
    "seoTitle": "Chirurgie de la gynécomastie à Istanbul | Clinique Platinya",
    "seoDesc": "Gynécomastie à Istanbul : exérèse de la glande avec liposuccion, après avoir écarté les causes hormonales. Trois à quatre semaines de compression."
  },
  "/gastric-sleeve-surgery": {
    "title": "Sleeve gastrique à Istanbul",
    "eyebrow": "Chirurgie de l’obésité",
    "lead": "L’estomac est remodelé en un tube étroit — environ 60 à 70 % est retiré — de sorte qu’il contient beaucoup moins et se vide plus lentement. C’est un outil qui rend l’appétit et les portions plus faciles à gérer ; il ne fait pas perdre le poids à votre place.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de sleeve gastrique à la clinique Platinya",
    "stats": [
      {
        "value": "1–2 h",
        "label": "Durée de l’intervention"
      },
      {
        "value": "2–3 nuits",
        "label": "Hospitalisation"
      },
      {
        "value": "12–18 mois",
        "label": "Jusqu’à stabilisation du poids"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "La décision ne se prend pas sur le poids seul. Elle repose sur l’indice de masse corporelle, sur les maladies liées au surpoids, sur ce qui a déjà été tenté avec un encadrement — et sur une volonté réelle d’être suivi pendant des années, pas des mois.",
      "items": [
        "Un IMC de 40 ou plus, ou de 35 ou plus avec une maladie liée au poids comme un diabète de type 2, une hypertension artérielle ou une apnée du sommeil",
        "Un IMC de 30 ou plus avec un diabète de type 2 mal équilibré — autorisé par certaines recommandations internationales, décidé au cas par cas",
        "Des tentatives structurées antérieures de perte de poids — régime, activité, accompagnement comportemental — qui ne se sont pas maintenues sur le long terme",
        "Un engagement dans un suivi à vie : analyses de sang, compléments et visites, y compris les années où le poids est stable"
      ],
      "note": "Aucune intervention n’est programmée avant une évaluation psychologique, une consultation anesthésique et une évaluation diététique. Une consommation de substances active ou une maladie psychiatrique non traitée reporte la chirurgie jusqu’à leur prise en charge — non par règle, mais parce que le suivi n’y survivrait pas."
    },
    "techniques": {
      "heading": "Comment l’intervention est réalisée",
      "intro": "Le principe est le même dans tous les cas ; ce qui change, c’est le diamètre du tube laissé en place et la réparation éventuelle d’une hernie dans le même temps.",
      "items": [
        {
          "name": "Sleeve par cœlioscopie",
          "text": "Cinq ou six petites incisions, une caméra et des agrafeuses qui sectionnent l’estomac le long de la grande courbure. La partie ouverte est retirée par l’un des trocarts, de sorte que l’estomac restant est un tube plutôt qu’une poche avec un court-circuit."
        },
        {
          "name": "Calibrage — le diamètre du tube",
          "text": "Le tube est construit sur une bougie de calibrage passée par la bouche, typiquement 36 à 40 French. Plus étroit donne plus de restriction mais aussi plus de rétrécissement et de reflux ; plus large en donne moins. C’est un jugement chirurgical, pas un choix du patient."
        },
        {
          "name": "Réparation de hernie hiatale et reflux",
          "text": "Le diaphragme est inspecté pendant l’intervention, et une hernie hiatale est réparée dans la même séance si elle est trouvée. Un reflux préexistant peut s’aggraver après un sleeve : il est donc évalué au préalable et modifie parfois l’intervention choisie."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation au suivi à long terme",
      "steps": [
        {
          "name": "Évaluation",
          "text": "Analyses de sang incluant fer, B12, folates, vitamine D et bilan thyroïdien ; une endoscopie si indiquée ; une évaluation diététique ; une évaluation psychologique ; et un avis anesthésique. C’est seulement ensuite qu’une date est proposée."
        },
        {
          "name": "Les deux semaines précédentes",
          "text": "Un régime hypocalorique, généralement liquide ou très bas en énergie, réduit le foie pour que l’estomac soit accessible en sécurité. Le tabac est arrêté au moins quatre semaines avant. Les anticoagulants sont suspendus sur instruction."
        },
        {
          "name": "L’intervention et le séjour",
          "text": "Sous anesthésie générale, une à deux heures. La plupart des patients restent deux à trois nuits. Un contrôle radiologique avec produit de contraste est réalisé au premier ou deuxième jour en cas de doute sur la ligne d’agrafage, et l’alimentation liquide commence le jour même."
        },
        {
          "name": "Les six premières semaines",
          "text": "Liquides pendant une à deux semaines, purées pendant deux semaines, aliments mous pendant deux semaines, puis textures normales. Petites portions, mangées lentement, protéines d’abord et boissons à distance des repas. Le travail de bureau est généralement possible après deux à trois semaines."
        },
        {
          "name": "Le long terme",
          "text": "Vitamine B12, fer, folates, vitamine D et calcium à vie, avec des analyses à trois, six et douze mois puis annuellement. Le suivi continue lorsque le poids se stabilise — c’est là qu’apparaissent les carences et la reprise de poids."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Un sleeve est une modification définitive d’un organe sain. Voici les complications dont les patients sont réellement avertis, et la raison pour laquelle l’intervention se pratique dans un hôpital avec une prise en charge bariatrique.",
      "items": [
        "Fistule sur la ligne d’agrafage chez environ 1 à 3 % des patients, généralement entre le troisième et le dixième jour ; elle nécessite un drainage, parfois une prothèse, exceptionnellement une nouvelle chirurgie",
        "Saignement de la ligne d’agrafage ou de la rate, pouvant nécessiter une transfusion et, rarement, une réintervention",
        "Rétrécissement ou torsion du tube, provoquant des vomissements répétés et une difficulté à avaler, traités par dilatation endoscopique",
        "Un reflux acide nouveau ou aggravé — l’une des plaintes les plus fréquentes après un sleeve, et une raison pour laquelle certains patients sont orientés vers un bypass",
        "Carence à long terme en B12, fer, folates, vitamine D et calcium si les compléments et la surveillance sont abandonnés"
      ],
      "note": "La reprise de poids survient, le plus souvent à partir de la troisième année, quand les portions augmentent et que le suivi s’arrête. La chirurgie est un outil, pas une guérison : elle ouvre une fenêtre pendant laquelle les habitudes alimentaires peuvent être reconstruites, et cette fenêtre se referme si rien n’est reconstruit à l’intérieur."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de poids vais-je perdre ?",
          "a": "Typiquement environ 25 à 30 % du poids corporel total sur la première ou les deux premières années, mais la variation entre patients est large et dépend du poids de départ, de l’observance et du suivi. Personne ne peut promettre un chiffre avant l’évaluation."
        },
        {
          "q": "Aurai-je besoin de compléments à vie ?",
          "a": "Dans la plupart des cas, oui — vitamine B12, fer, folates, vitamine D et calcium, avec des analyses pour les ajuster. L’estomac retiré produit le facteur intrinsèque et l’acide : l’absorption change donc définitivement."
        },
        {
          "q": "Peut-on revenir en arrière ?",
          "a": "L’estomac n’est pas restauré dans sa forme d’origine. Si un sleeve échoue — reflux sévère, perte de poids insuffisante, reprise de poids — l’étape suivante habituelle est la conversion en bypass gastrique, une opération plus lourde."
        },
        {
          "q": "Et une grossesse ensuite ?",
          "a": "La grossesse est possible, mais la plupart des chirurgiens conseillent d’attendre 12 à 18 mois pour que le poids et le statut nutritionnel soient stabilisés. Les compléments et la surveillance se poursuivent pendant la grossesse."
        }
      ]
    },
    "ctaBand": {
      "heading": "Envoyez votre taille, votre poids et votre historique médical",
      "text": "Un chirurgien bariatrique les examine et un coordinateur revient vers vous pour dire si une évaluation est pertinente, quels examens seraient nécessaires d’abord, et avec un devis écrit — sans obligation de réserver.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité ne peut être jugée qu’après une évaluation complète par un chirurgien bariatrique, incluant un bilan psychologique et nutritionnel ; résultats et risques varient d’un patient à l’autre.",
    "seoTitle": "Sleeve gastrique à Istanbul | Clinique Platinya",
    "seoDesc": "Sleeve gastrique par cœlioscopie à Istanbul : environ 70 % de l’estomac retiré, deux à trois nuits d’hospitalisation, suivi vitaminique à vie."
  },
  "/stomach-balloon": {
    "title": "Ballon gastrique à Istanbul",
    "eyebrow": "Chirurgie de l’obésité",
    "lead": "Un ballon est placé dans l’estomac et gonflé, de sorte qu’il reste moins de place pour la nourriture et que la satiété arrive plus vite. Il reste en place six à douze mois puis est retiré. C’est une aide temporaire, ni une opération ni une guérison de l’obésité.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de ballon gastrique à la clinique Platinya",
    "stats": [
      {
        "value": "20–30 min",
        "label": "Pose"
      },
      {
        "value": "6–12 mois",
        "label": "Temps en place"
      },
      {
        "value": "3–7 jours",
        "label": "Pour se stabiliser"
      }
    ],
    "candidate": {
      "heading": "Qui est un bon candidat",
      "intro": "Un ballon convient à quelqu’un qui doit perdre un poids significatif avant autre chose — chirurgie articulaire, traitement de fertilité, réparation d’une hernie — ou qui a besoin d’une période de départ définie pour changer ses habitudes alimentaires sous surveillance. Il ne convient pas à qui cherche une procédure qui fasse le travail seule.",
      "items": [
        "Un IMC d’environ 27 à 35, sans contre-indication à l’endoscopie",
        "Un poids qui n’a pas répondu à un régime et une activité encadrés, ou une raison médicale de perdre du poids rapidement",
        "Aucune chirurgie gastrique ou œsophagienne antérieure, et pas de grande hernie hiatale ni d’ulcère actif",
        "La volonté de suivre un programme diététique pendant les mois de port, et après le retrait"
      ],
      "note": "Le ballon n’est pas un traitement d’un IMC supérieur à 40 à lui seul, et il n’est pas proposé aux femmes enceintes, à celles qui planifient une grossesse dans l’année, ni en cas de trouble du comportement alimentaire actif. Le bilan comprend un historique médical, des analyses de sang et, selon le dispositif, une endoscopie."
    },
    "techniques": {
      "heading": "Les deux façons de poser un ballon",
      "intro": "Les deux occupent de l’espace dans l’estomac. Ce qui diffère, c’est la façon dont ils arrivent, la durée de port et la nécessité d’une sédation.",
      "items": [
        {
          "name": "Ballon endoscopique",
          "text": "Posé par la bouche avec un gastroscope sous sédation, puis rempli de sérum physiologique et d’un colorant pour qu’une fuite soit visible. Cela prend environ 20 à 30 minutes. Il est retiré de la même manière à la fin de sa période autorisée, généralement six ou douze mois."
        },
        {
          "name": "Ballon déglutissable",
          "text": "Une capsule est avalée avec de l’eau, contrôlée à la radiographie, puis remplie de gaz par un fin cathéter. Ni sédation ni endoscopie. Il reste environ quatre mois et est conçu pour être éliminé naturellement, même si un retrait par endoscopie est parfois nécessaire."
        },
        {
          "name": "Le programme autour",
          "text": "Aucun des deux dispositifs ne fonctionne sans le régime qui l’accompagne : un plan mené par une diététicienne, des objectifs protéiques, un suivi comportemental et une transition structurée vers l’alimentation normale dans les semaines précédant le retrait. C’est cette partie qui détermine le résultat."
        }
      ]
    },
    "journey": {
      "heading": "Du bilan à la vie après le retrait",
      "steps": [
        {
          "name": "Bilan",
          "text": "Historique médical, revue des traitements, analyses de sang et endoscopie si le dispositif l’exige. Tout ulcère, hernie ou reflux est traité avant la pose, pas après."
        },
        {
          "name": "Le jour de la pose",
          "text": "Généralement en ambulatoire. Sédation pour la version endoscopique ; seulement de l’eau et une capsule pour la version déglutissable. Vous êtes surveillé quelques heures, recevez un traitement antiémétique, et rentrez le jour même."
        },
        {
          "name": "La première semaine",
          "text": "Nausées, crampes et vomissements sont fréquents et attendus — l’estomac proteste contre ce qu’on lui a mis à l’intérieur. Antivomitifs, petites quantités de liquide et, si besoin, perfusion. La plupart des personnes se stabilisent en trois à sept jours."
        },
        {
          "name": "Les mois de port",
          "text": "Liquides, puis aliments mous, puis textures normales sur deux à trois semaines. Les portions sont plus petites parce que l’estomac est plus petit. Consultations diététiques toutes les quatre à six semaines ; analyses de sang si les apports restent bas."
        },
        {
          "name": "Le retrait et après",
          "text": "Le retrait dure 20 à 30 minutes. L’appétit revient généralement en quelques jours à quelques semaines, et sans les habitudes construites pendant le programme, le poids revient. Un plan de maintenance — suivi diététique, activité, parfois médicament — est validé avant le retrait du ballon."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Un ballon est moins invasif que la chirurgie, pas sans risque. Voici les complications discutées avant la pose.",
      "items": [
        "Nausées, vomissements et crampes abdominales la première semaine, parfois assez sévères pour nécessiter une perfusion",
        "Reflux, brûlures d’estomac et irritation de l’œsophage ou de la muqueuse gastrique pendant le port du ballon",
        "Dégonflement ou migration du ballon, pouvant obstruer l’intestin — rare, et une urgence lorsque cela survient",
        "Ulcération, érosion ou, très rarement, perforation de la paroi gastrique, nécessitant une chirurgie",
        "Reprise de poids après le retrait, fréquente lorsque le programme diététique n’est pas poursuivi"
      ],
      "note": "Un ballon achète du temps et un estomac plus petit, rien de plus. Il ne change pas la façon dont le corps traite les aliments, ne traite pas les raisons pour lesquelles manger était difficile, et la perte de poids est généralement modeste — typiquement entre 5 % et 15 % du poids corporel pendant qu’il est en place."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Combien de poids vais-je perdre ?",
          "a": "Couramment de l’ordre de 5 à 15 % du poids corporel sur la durée de port, avec de grandes variations. C’est moins qu’un sleeve ou qu’un bypass, et une partie est souvent reprise après le retrait."
        },
        {
          "q": "Est-ce douloureux ?",
          "a": "La pose n’est pas douloureuse — la gorge est anesthésiée et une sédation est utilisée. Les trois à sept premiers jours sont généralement inconfortables : nausées, crampes et vomissements. Un traitement antiémétique est prescrit avant votre sortie."
        },
        {
          "q": "Puis-je manger normalement avec ?",
          "a": "Des textures normales, oui ; des portions normales, non. Manger trop vite ou trop abondamment provoque douleur et vomissements, et les boissons gazeuses ainsi que les aliments très fibreux sont mal tolérés par certains patients."
        },
        {
          "q": "Que se passe-t-il au retrait ?",
          "a": "L’estomac retrouve sa taille antérieure en quelques jours. L’appétit revient souvent vite. La stabilisation du poids dépend de ce qui a été construit pendant ces mois, c’est pourquoi le programme diététique compte plus que le dispositif."
        }
      ]
    },
    "ctaBand": {
      "heading": "Sachez si un ballon est le bon point de départ",
      "text": "Envoyez votre taille, votre poids et votre historique médical. Un médecin bariatrique les examine et un coordinateur revient vers vous pour dire si un ballon ou une évaluation chirurgicale correspond à votre cas — et ce que cela implique.",
      "button": "Parler à un coordinateur"
    },
    "disclaimer": "Information générale, pas un avis médical. La faisabilité dépend d’une évaluation par un médecin bariatrique, incluant l’historique médical et, si indiqué, une endoscopie ; les résultats varient d’un patient à l’autre.",
    "seoTitle": "Ballon gastrique à Istanbul | Clinique Platinya",
    "seoDesc": "Ballon gastrique à Istanbul : six à douze mois de contrôle de l’appétit, posé par endoscopie ou par capsule. Ce qui se passe après le retrait."
  },
  "/filler": {
    "title": "Fillers dermiques à Istanbul",
    "eyebrow": "Médecine esthétique",
    "lead": "L’acide hyaluronique est un sucre que la peau contient déjà. Réticulé en gel et placé sous la peau, il restaure le volume perdu et adoucit les plis installés. C’est un acte médical avec de vrais risques, pas un soin de beauté.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de fillers dermiques à la clinique Platinya",
    "stats": [
      {
        "value": "30–60 min",
        "label": "Rendez-vous"
      },
      {
        "value": "6–18 mois",
        "label": "Durée"
      },
      {
        "value": "24–72 h",
        "label": "Œdème et hématomes"
      }
    ],
    "candidate": {
      "heading": "À qui cela convient, et à qui non",
      "intro": "Le bon candidat a une préoccupation précise et descriptible — un pli, un creux, un contour perdu — plutôt que le désir de ressembler à quelqu’un d’autre. Le volume est remplacé là où il a disparu, pas ajouté partout où c’est possible.",
      "items": [
        "Une perte de volume dans les pommettes, les tempes ou le tiers moyen du visage, ou des plis qui persistent au repos",
        "Une ligne de mâchoire ou un menton qui ont perdu leur définition, ou des lèvres amincies avec l’âge plutôt que naturellement peu volumineuses",
        "Un bon état de santé général, sans infection active ni inflammation cutanée dans la zone à traiter",
        "Des attentes réalistes : les fillers restaurent du volume, ils ne remontent pas un visage relâché et ne suppriment pas la laxité cutanée"
      ],
      "note": "Les fillers ne sont pas injectés pendant la grossesse ou l’allaitement, sur une acné active, un herpès labial ou une infection, ni en cas d’allergie connue à l’acide hyaluronique ou à la lidocaïne. Les anticoagulants et certains compléments augmentent le risque d’hématome et sont revus au préalable, pas ignorés. Toute demande de filler permanent est refusée et orientée vers un avis chirurgical."
    },
    "techniques": {
      "heading": "Produit, plan de placement, et quantité",
      "intro": "Le résultat dépend bien plus de l’endroit où le produit est placé et de la quantité utilisée que de la marque sur la boîte.",
      "items": [
        {
          "name": "Choisir le gel",
          "text": "Les fillers d’acide hyaluronique diffèrent par l’intensité de leur réticulation et par la fermeté du gel. Des gels souples pour les lèvres et les ridules, des gels plus fermes pour les plans profonds sur l’os. La plupart contiennent de la lidocaïne, ce qui rend l’injection plus confortable."
        },
        {
          "name": "Aiguille ou canule, et quel plan",
          "text": "L’aiguille est précise pour les lèvres et les plis fins ; une canule mousse réduit les hématomes et permet de déposer le produit sur un seul trajet. Un placement profond sur l’os soutient ; un placement superficiel affine. Le plan est une décision clinique, pas une préférence."
        },
        {
          "name": "Doses prudentes, par étapes",
          "text": "Sous-corriger et revoir à deux ou quatre semaines est plus sûr que tout corriger en une séance. Un tissu surcorrigé se distend, et une peau distendue ne se rétracte pas — c’est ainsi que des visages finissent par paraître remplis plutôt que reposés."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation au contrôle",
      "steps": [
        {
          "name": "Consultation",
          "text": "Le visage est évalué au repos et en mouvement, des photographies sont prises et l’historique médical est revu — grossesse, maladie auto-immune, herpès labial, fillers antérieurs et leur localisation. Un filler permanent antérieur modifie entièrement le plan."
        },
        {
          "name": "Planification et consentement",
          "text": "Les zones, le produit, le volume et le coût sont validés par écrit avant toute ouverture de produit. Les risques sont expliqués, y compris l’occlusion vasculaire, et il vous est précisé que l’hyaluronidase — l’enzyme qui dissout le produit — est conservée à la clinique."
        },
        {
          "name": "Le rendez-vous",
          "text": "Trente à soixante minutes, crème anesthésiante comprise. Les injections prennent dix à vingt de ces minutes. Les lèvres et le sillon lacrymal sont les zones les plus sensibles ; la plupart des personnes décrivent une pression plutôt qu’une douleur."
        },
        {
          "name": "Les 72 premières heures",
          "text": "L’œdème atteint son maximum à 24–48 heures, et les hématomes peuvent mettre une semaine à s’effacer. Évitez la chaleur, le sauna, le sport intense et l’alcool pendant 24 à 48 heures, et les soins dentaires pendant deux semaines si les lèvres ou la zone nasogénienne ont été traitées. Dormir légèrement surélevé aide la première nuit."
        },
        {
          "name": "Contrôle à deux à quatre semaines",
          "text": "Le résultat s’apprécie une fois l’œdème disparu. Une petite retouche est parfois indiquée ; aucune correction n’est faite la première semaine, quand tout paraît plus volumineux que cela ne le sera. La suite est planifiée selon la durée réelle du produit dans vos tissus."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Ce sont des injections médicales dans une zone très vascularisée. Les risques graves sont rares, mais c’est la raison pour laquelle cet acte se pratique dans une clinique avec un médecin présent et un agent de réversion au réfrigérateur.",
      "items": [
        "Hématomes, œdème et sensibilité pendant quelques jours — fréquents, et plus marqués avec les anticoagulants",
        "Occlusion vasculaire — le produit bloque une artère, provoquant douleur, blanchiment et, sans traitement, nécrose cutanée et cicatrices ; l’hyaluronidase doit être administrée dans les heures qui suivent",
        "Perte de vision par embolisation dans la circulation rétinienne — très rare, largement irréversible, et raison pour laquelle certaines zones ne sont traitées que par des injecteurs expérimentés",
        "Nodules, indurations ou réactions inflammatoires retardées plusieurs mois plus tard, parfois déclenchées par une maladie ou une vaccination",
        "Asymétrie, migration du produit, ou un aspect sur-rempli qui ne peut pas être entièrement annulé en une séance"
      ],
      "note": "L’acide hyaluronique peut être dissous par l’hyaluronidase, et c’est pourquoi c’est le seul filler qui vaille la peine d’être utilisé au visage. Les produits permanents et les substances non étiquetées ne peuvent pas être retirés, et ils sont la raison la plus fréquente pour laquelle un patient est refusé ou adressé en chirurgie."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Est-ce douloureux ?",
          "a": "Une crème anesthésiante est appliquée pendant vingt à trente minutes, et la plupart des produits contiennent de la lidocaïne. Les lèvres et la zone sous l’œil sont les plus sensibles — un inconfort plutôt qu’une douleur, et cela dure quelques secondes par injection."
        },
        {
          "q": "Peut-on l’annuler ?",
          "a": "Oui, s’il s’agit d’acide hyaluronique : l’hyaluronidase le dissout en un jour ou deux. Ce n’est pas une raison de surcharger, mais c’est pourquoi le produit compte plus que le prix."
        },
        {
          "q": "Cela se verra-t-il ?",
          "a": "Non si le produit est placé dans le bon plan et en quantité prudente. Un résultat visible signifie généralement trop de produit, trop superficiel, dans une zone qui avait besoin de soutien plutôt que de volume."
        },
        {
          "q": "À quelle fréquence faudra-t-il en refaire ?",
          "a": "Tous les six à dix-huit mois selon le produit, la zone et la vitesse à laquelle vous le dégradez. Les lèvres et les zones très mobiles demandent généralement une retouche plus tôt que le soutien profond des pommettes."
        }
      ]
    },
    "ctaBand": {
      "heading": "Demandez à un médecin ce dont votre visage a réellement besoin",
      "text": "Envoyez deux photographies — face et trois quarts, au repos — et un médecin les examine. Vous obtenez une réponse honnête sur l’intérêt d’un filler, et sur ce qui pourrait l’être aussi.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. Les fillers sont des dispositifs médicaux sur prescription et ne sont appropriés qu’après consultation d’un praticien qualifié ; la faisabilité diffère d’un patient à l’autre.",
    "seoTitle": "Fillers dermiques à Istanbul | Clinique Platinya",
    "seoDesc": "Fillers à l’acide hyaluronique à Istanbul : trente à soixante minutes, six à dix-huit mois. Risques vasculaires, et pourquoi plus n’est pas mieux."
  },
  "/face-botox": {
    "title": "Botox du visage à Istanbul",
    "eyebrow": "Médecine esthétique",
    "lead": "La toxine botulique bloque le signal qui ordonne à un muscle de se contracter. Injectée à petites doses mesurées dans le tiers supérieur du visage, elle adoucit les rides que le mouvement a creusées — et l’effet s’estompe, ce qui est précisément l’intérêt.",
    "cta": "Réserver une évaluation gratuite",
    "heroAlt": "Consultation de toxine botulique à la clinique Platinya",
    "stats": [
      {
        "value": "15–30 min",
        "label": "Rendez-vous"
      },
      {
        "value": "10–14 jours",
        "label": "Effet complet"
      },
      {
        "value": "3–4 mois",
        "label": "Durée"
      }
    ],
    "candidate": {
      "heading": "À qui cela convient, et à qui non",
      "intro": "Une toxine traite les rides créées par le mouvement. Elle ne fait rien pour le volume perdu ni pour une peau relâchée — ceux-là demandent un filler ou de la chirurgie, et proposer une toxine dans ces cas est la manière dont les patients finissent déçus.",
      "items": [
        "Rides du lion entre les sourcils, rides horizontales du front et pattes d’oie visibles au mouvement",
        "Des rides encore dynamiques — elles apparaissent quand vous froncez les sourcils ou souriez — plutôt que creusées au repos",
        "Un bon état de santé général, sans raison d’éviter un médicament sur ordonnance",
        "Des attentes réalistes : le visage paraît moins tendu, pas plus jeune, et l’effet est temporaire"
      ],
      "note": "La toxine botulique n’est pas administrée pendant la grossesse ou l’allaitement, ni en cas de maladie neuromusculaire telle que la myasthénie, le syndrome de Lambert-Eaton ou la sclérose latérale amyotrophique, ni en cas d’allergie connue au produit ou à son support albumine. Une infection active au point d’injection et un ptosis palpébral préexistant sont des raisons relatives d’attendre ou de traiter autrement."
    },
    "techniques": {
      "heading": "Où l’on injecte, et combien",
      "intro": "Les doses s’expriment en unités propres à chaque marque et ne se comparent pas entre elles. Ce qui compte, c’est le schéma d’injection, choisi selon la façon dont vos muscles bougent réellement.",
      "items": [
        {
          "name": "Glabelle — les rides du lion",
          "text": "Généralement la première zone traitée, typiquement 20 à 30 unités réparties sur cinq points d’injection. C’est la zone au résultat le plus fiable, et aussi celle où une dose mal placée peut provoquer une ptose de la paupière."
        },
        {
          "name": "Front",
          "text": "Typiquement 10 à 20 unités, placées pour adoucir les rides horizontales sans aplatir totalement le sourcil. Traiter le front seul, sans la glabelle, fait souvent remonter le sourcil interne avec un aspect étrange — les zones se planifient ensemble."
        },
        {
          "name": "Pattes d’oie",
          "text": "Typiquement 6 à 12 unités par côté, sur trois points autour de l’œil externe. La zone est superficielle et proche du rebord orbitaire : les hématomes sont fréquents et la dose reste basse pour éviter un regard lourd et fermé."
        }
      ]
    },
    "journey": {
      "heading": "De la consultation au contrôle",
      "steps": [
        {
          "name": "Consultation",
          "text": "Le visage est observé au repos et au mouvement — froncer, lever les sourcils, plisser les yeux — car la dose se choisit d’après le muscle, pas d’après la ride. L’historique médical, les traitements et les injections antérieures de toxine sont revus, et des photographies sont prises."
        },
        {
          "name": "Le rendez-vous",
          "text": "Quinze à trente minutes. Aucune anesthésie n’est nécessaire ; de la glace est utilisée si vous le souhaitez. Une aiguille fine, plusieurs petites injections de quelques secondes chacune. Vous pouvez reprendre le travail immédiatement."
        },
        {
          "name": "Les 24 premières heures",
          "text": "Pas de frottement ni de massage de la zone pendant quatre heures, pas de position allongée pendant quatre heures, et pas de sport, de sauna ni d’alcool pendant 24 heures. Un léger mal de tête et de petits hématomes sont fréquents ; le maquillage peut être appliqué le jour même si la peau n’est pas lésée."
        },
        {
          "name": "Jours 3 à 14",
          "text": "L’effet débute vers le deuxième ou troisième jour et atteint son maximum à 10–14 jours. Juger le résultat plus tôt conduit à des retouches inutiles — le contrôle est programmé au quatorzième jour."
        },
        {
          "name": "Le contrôle, puis l’entretien",
          "text": "À deux semaines, le schéma est vérifié et une petite correction est faite si besoin. L’effet dure trois à quatre mois, parfois moins chez les personnes qui métabolisent vite. Un traitement tous les trois à quatre mois maintient le résultat sans augmenter les doses."
        }
      ]
    },
    "risks": {
      "heading": "Ce qui peut mal se passer",
      "intro": "Il s’agit d’un médicament sur ordonnance, et les risques sont ceux de la toxine elle-même plutôt que ceux de l’aiguille.",
      "items": [
        "Hématomes, œdème et léger mal de tête pendant un jour ou deux, plus fréquents autour des yeux",
        "Ptose de la paupière ou du sourcil chez environ 1 à 2 % des traitements de la glabelle — temporaire, se résorbant en deux à quatre semaines, parfois aidée par des collyres",
        "Asymétrie, ou un sourcil plus haut d’un côté, généralement corrigeable au contrôle des deux semaines",
        "Une expression artificielle — front aplati ou sourcil en accent circonflexe — liée à une dose ou à un schéma inadapté aux muscles",
        "Sécheresse oculaire, gonflement des paupières ou difficulté à lever le sourcil et, rarement, faiblesse généralisée ou réaction pseudo-grippale"
      ],
      "note": "Indiquez au praticien tous les médicaments et compléments, les traitements antérieurs par toxine et leur durée d’effet, ainsi que tout antécédent familial de maladie neuromusculaire. La toxine ne traite ni le relâchement cutané ni le volume perdu, et elle ne remplace pas un avis chirurgical lorsque c’est ce dont le visage a réellement besoin."
    },
    "faq": {
      "heading": "Les questions que posent les patients",
      "items": [
        {
          "q": "Mon visage va-t-il paraître figé ?",
          "a": "Pas à dose mesurée. L’objectif est d’adoucir le mouvement, pas de l’arrêter. L’aspect figé vient du traitement de toutes les zones à dose maximale — et c’est réversible, ce qui est son avantage sur la chirurgie."
        },
        {
          "q": "Quand verrai-je un résultat ?",
          "a": "Le mouvement commence à s’adoucir vers le deuxième ou troisième jour, et l’effet complet est présent à 10–14 jours. Ce qui paraît irrégulier avant ce délai est généralement encore en évolution."
        },
        {
          "q": "Que se passe-t-il si j’arrête ?",
          "a": "Le muscle retrouve son activité antérieure en quelques mois et les rides reviennent là où elles étaient. Il n’y a pas d’aggravation par rebond, même si des rides supprimées pendant des années peuvent paraître plus installées au début."
        },
        {
          "q": "Peut-on l’associer à un filler ?",
          "a": "Souvent oui — la toxine pour le mouvement, le filler pour le volume — et les deux sont fréquemment réalisés dans la même visite. L’ordre et le calendrier sont décidés par le praticien, car les deux modifient la façon d’évaluer le visage."
        }
      ]
    },
    "ctaBand": {
      "heading": "Demandez à un médecin si la toxine est la bonne réponse",
      "text": "Envoyez deux photos — en fronçant les sourcils et au repos — et un médecin les examine. Vous obtenez une réponse honnête sur le caractère musculaire des rides, et sur ce qu’il faudrait d’autre si elles ne le sont pas.",
      "button": "Envoyer vos photos"
    },
    "disclaimer": "Information générale, pas un avis médical. La toxine botulique est un médicament sur ordonnance, administré uniquement après consultation d’un praticien qualifié ; la faisabilité et la dose varient d’un patient à l’autre.",
    "seoTitle": "Toxine botulique (Botox) à Istanbul | Clinique Platinya",
    "seoDesc": "Toxine botulique à Istanbul pour le haut du visage : effet complet en dix à quatorze jours, trois à quatre mois par traitement. Contre-indications."
  },
};
